{
  "404.message": "Страница, которую вы запросили, не найдена. Возможные причины:",
  "404.message.reason1": "Данная страница не существует.",
  "404.message.reason2": "Данная страница существует, но у вас нет прав доступа к ней.",
  "404.nav.dashboard": "Ваша панель инструментов",
  "404.nav.home": "Домашняя страница сайта",
  "404.nav.title": "Переход к",
  "404.search.title": "Поиск по сайту",
  "aboutpage.section.title": "Atlassian Confluence Cloud и плагины для Confluence Cloud",
  "accessibility.user.icon": "Иконка пользователя",
  "action.add.comment": "Добавить комментарий",
  "action.edit.comment": "Редактировать комментарий",
  "action.reorder.pages.sentence": "Изменить порядок страниц",
  "action.space.addons": "Дополнения",
  "action.space.overview": "Обзор",
  "actions.word": "Действия",
  "add.comment": "Добавить комментарий",
  "add.comment.accesskey": "м",
  "add.shortcut": "Добавить быструю ссылку",
  "add.word": "Добавить",
  "addlabels.teamlabels": "Категории",
  "adf.translation.error.in.render.description.prod": "Обновите страницу и повторите попытку. Если это не решит проблему, обратитесь в <a target=\"_blank\" href=\"{link}\">службу поддержки Atlassian</a>.",
  "adf.translation.error.in.render.description.staging": "Не удалось отобразить контент из-за ошибки ADF. Чтобы обсудить эту проблему, перейдите на канал <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> в Slack.",
  "adf.translation.error.in.render.title.prod": "Не удалось показать контент",
  "adf.translation.error.in.render.title.staging": "Ошибка ADF при показе контента",
  "adg3.feedback.placeholder": "Расскажите нам о своем опыте использования Confluence, чтобы мы могли сделать его еще лучше.",
  "adg3.give.feedback": "Оставить отзыв",
  "adg3.onboarding.docs.link": "Узнать больше",
  "adg3.onboarding.next": "Далее",
  "adg3.onboarding.prev": "Назад",
  "adg3.onboarding.sidebar.done": "Понятно",
  "adg3.onboarding.skip": "Пропустить",
  "adg3.onboarding.start": "Начать",
  "adg3.onboarding.step1.content": "Мы обновили цвета, значки и шрифты. Теперь будет легче замечать важные моменты и не нужно сильно напрягать глаза.",
  "adg3.onboarding.step1.title": "Поприветствуйте новый опыт Confluence",
  "adg3.onboarding.step2.content": "Самые популярные функции — поиск, создание, навигация — находятся на боковой панели.",
  "adg3.onboarding.step2.title": "Простая навигация по боковой панели",
  "adg3.onboarding.step3.content": "Не можете вспомнить, над чем работали? Панель поиска подскажет вам список недавно просмотренных страниц.",
  "adg3.onboarding.step3.title": "Вернуться к шагу, на котором вы остановились",
  "adg3.onboarding.step4.content": "Оставьте отзыв через свой профиль, чтобы помочь сделать Confluence еще лучше. Еще не готовы к новому опыту? Вы также можете отключить его через свой профиль.",
  "adg3.onboarding.step4.content.no.optout": "Ваш отзыв играет важную роль в улучшении Confluence. Дайте нам знать, что вы думаете о своем профиле, чтобы помочь нам сделать его еще лучше.",
  "adg3.onboarding.step4.title": "Помогите нам улучшить Confluence",
  "adg3.onboarding.user.optin.content": "Ваши отзывы помогли нам улучшить продукт, но нет предела совершенству! Поделитесь с нами своими идеями, нажав кнопку 'Оставить отзыв' на боковой панели.",
  "adg3.onboarding.user.optin.done": "Понятно",
  "adg3.onboarding.user.optin.title": "Новинки Confluence теперь доступны для всех",
  "adg3.send.feedback": "Оставить отзыв",
  "adg3.sidebar.button.configure": "Настроить боковую панель",
  "adg3.sidebar.button.done": "Готово",
  "adg3.sidebar.button.gotit": "ОК",
  "adg3.sidebar.link.disable": "Отключить",
  "adg3.sidebar.link.enable": "Включить",
  "adg3.user.profile.other": "Мое влияния",
  "admin.section.security.title": "Пользователи & Безопастность",
  "administration.name": "Администрирование",
  "all.updates.mainBanner": "Пока что здесь тихо...",
  "all.updates.subBanner": "Оставайтесь в курсе всего происходящего здесь. Здесь будут появляться новые страницы, файлы, исправления и комментарии.",
  "all.updates.subBanner2": "Пора создать еще что-нибудь грандиозное.",
  "all.updates.title": "Все обновления",
  "anonymous.name": "Анонимный",
  "archived.spaces": "Архив разделов",
  "atlassian.can.contact": "Мы можем связаться с вами, чтобы задать вопросы по вашему отзыву?",
  "atlassian.home.name": "Atlassian Home",
  "attach.files.no.permission": "Необходимо запросить разрешение на вставку файлов сюда.",
  "attach.files.tip.close": "Ок, я понял!",
  "attach.files.tip.desc": "Чтобы добавить файлы сюда, перетащите их прямо на вашу страницу.",
  "attach.files.tip.title": "Подсказка:",
  "attach.files.upload.files": "Загрузить файлы",
  "attach.files.upload.images": "Загрузить изображения",
  "audit.logging.category.user.management": "Пользователи и группы",
  "aui.sidebar.collapse.tooltip": "Свернуть колонку ( [ )",
  "aui.sidebar.expand.tooltip": "Раскрыть колонку ( [ )",
  "author.name": "Автор",
  "blog.personal.name": "Личный блог",
  "blog.post": "Сообщение в блоге",
  "blog.word": "Блог",
  "blogtree.failed.load.content": "Не удалось загрузить записи в блоге",
  "blueprint.navigation.items.create.new.template": "Создать новый шаблон",
  "blueprint.navigation.items.create.new.template.disabled": "Шаблоны могут создавать только администраторы разделов",
  "blueprint.navigation.items.filter.for.templates": "Фильтр по шаблонам",
  "blueprint.navigation.items.page.templates.header": "Шаблоны страниц",
  "button.cancel": "Отмена",
  "cache.name.com.atlassian.confluence.pages.Draft": "Черновики",
  "calendar.share.button.keyboard.shortcut.desc": "Поделиться",
  "calendar3.addcalendar": "Добавить календарь",
  "calendar3.helptip.learn.more": "Узнать больше",
  "calendar3.spacecalendars.header": "Календари",
  "calendar3.spacecalendars.onboarding.button.add.label": "Добавить календарь",
  "calendar3.spacecalendars.onboarding.intro": "Добавьте календарь, чтобы отслеживать отпуск вашей команды, планировать проекты Jira и собрать всех вместе во время важных мероприятий.",
  "calendar3.spacecalendars.onboarding.title": "Источник правды для вашей команды или проекта",
  "cancel.name": "Отменить",
  "captcha.response.failed": "Введенное слово не соответствует тексту на картинке.",
  "categories.name": "Категории",
  "changeboarding.dnd.pagetree.spacesettings.banner": "Управлять разделами стало проще: теперь вы можете изменять порядок страниц, просто перетаскивая их в нужное место на боковой панели",
  "changeboarding.dnd.pagetree.spotlight.message": "Страницы можно перемещать путем перетаскивания, чтобы организовать раздел.",
  "changes-diff.heading.key": "Условное обозначение",
  "changes-diff.these.lines.were.added": "Эта строка добавлена.",
  "changes-diff.these.lines.were.removed": "Эта строка удалена.",
  "changes-diff.this.content.was.modified": "Изменено форматирование.",
  "clear.name": "Очистить",
  "clipboardaccess.browser.not.supported": "Ваш браузер не поддерживает вставку изображения из буфера обмена.",
  "clipboardaccess.ok": "Ок",
  "close.draft.name": "Закрыть черновик",
  "close.name": "Закрыть",
  "collab.edit.user.limit.msg.body": "<p>Эта страница так популярна, что вы достигли максимального количества одновременных редакторов.</p><p>Повторите попытку, когда она будет менее загружена.</p>",
  "collab.edit.user.limit.msg.title": "Вы не можете отредактировать эту страницу прямо сейчас",
  "collab.status.connected": "Готово к использованию",
  "collab.status.connecting": "Подключение…",
  "collab.status.error": "Не удалось сохранить изменения",
  "collab.status.tooltip.error": "Скопируйте свою работу, обновите страницу, и мы попытаемся подключиться повторно.",
  "collab.status.tooltip.failure": "Невозможно подключить к серверу. Проверьте соединение с Интернет, попытки восстановления подключения будут продолжены.",
  "collab.status.tooltip.success": "Мы автоматически сохраняем ваши изменения",
  "collapse.name": "Свернуть",
  "colourname.property.style.bordercolour": "Границы и Разделители",
  "colourname.property.style.breadcrumbstextcolour": "Текст верхней полосы",
  "colourname.property.style.headerbuttonbasebgcolour": "Фон кнопки заголовка",
  "colourname.property.style.headerbuttontextcolour": "Текст кнопки",
  "colourname.property.style.headingtextcolour": "Текст заголовка",
  "colourname.property.style.linkcolour": "Ссылки",
  "colourname.property.style.menuitemselectedbgcolour": "Фон Выбранного Пункта Меню",
  "colourname.property.style.menuitemselectedtextcolour": "Текст Выбранного Пункта Меню",
  "colourname.property.style.menuitemtextcolour": "Текст Пункта Меню Страницы",
  "colourname.property.style.menuselectedbgcolour": "Фон Выбранного Меню Страницы",
  "colourname.property.style.navbgcolour": "Фон Закладок",
  "colourname.property.style.navselectedbgcolour": "Фон Верхней Закладки",
  "colourname.property.style.navselectedtextcolour": "Текст Верхней Закладки",
  "colourname.property.style.navtextcolour": "Текст Закладок",
  "colourname.property.style.searchfieldbgcolour": "Фон поля поиска",
  "colourname.property.style.searchfieldtextcolour": "Текст поля поиска",
  "colourname.property.style.spacenamecolour": "Текст имени раздела",
  "colourname.property.style.topbarcolour": "Верхняя Панель",
  "colourname.property.style.topbarmenuitemtextcolour": "Текст Пункта Меню на Верхней Панели",
  "colourname.property.style.topbarmenuselectedbgcolour": "Фон выбранного меню на верхней панели",
  "colourname.property.style.topbarmenuselectedtextcolour": "Выбранный текст в меню верхней полосы",
  "com.atlassian.confluence.contributors.contributors.label": "Участники",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "Просмотр файла",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "Понятно, спасибо!",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "Редактирование Страницы",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "Roadmap Планировщик",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "Дерево страниц",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "Фильтр",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "Подсказка: нажмите \"g\", затем \"r\" в любом месте для быстрого доступа к этому меню",
  "com.atlassian.confluence.plugins.recently.viewed.title": "Недавно просмотренные страницы",
  "com.atlassian.confluence.plugins.status-macro.status.label": "Статус",
  "com.atlassian.mywork.header.notifications": "Уведомления",
  "comment.display.name.anonymous": "Анонимный",
  "comment.edit": "Редактировать",
  "comment.edited": "Изменено",
  "comment.name.tooltip": "Добавить комментарий",
  "comment.notification.enable": "Посмотрите эту страницу",
  "comment.permalink": "Постоянная ссылка",
  "comment.plural": "{0} Комментариев",
  "comment.remove": "Удалить",
  "comment.reply": "Ответить",
  "comment.singular": "1 комментарий",
  "compare.selected": "Сравнить выбранные версии",
  "configuration.name": "Конфигурация",
  "confluence.extra.attachments.attachments.label": "Вложения",
  "confluence.extra.jira.jira.label": "JIRA",
  "confluence.extra.masterdetail.detailssummary.label": "Отчет по свойствам страницы",
  "confluence.home": "Основная папка Confluence",
  "confluence.macros.advanced.children.label": "Отображение дочерних элементов",
  "confluence.macros.advanced.contentbylabel.label": "Содержимое по меткам",
  "confluence.macros.advanced.recently-updated.label": "Недавно обновлено",
  "confluence.mobile.nav.switch.to.mobile.action": "Переключитесь на Confluence mobile",
  "confluence.mobile.nav.switch.to.mobile.text": "Вы просматриваете версию для компьютера на мобильном устройстве.",
  "confluence.mobile.refresh": "Обновить",
  "confluence.request.access.pagerestricted.inherited.description": "Причина: ограничения, унаследованные от родительской страницы. Доступ может предоставить администратор раздела или тот, кто поделился этой страницей.",
  "confluence.request.access.pagerestricted.request.access.button": "Запрос доступа",
  "confluence.request.access.pagerestricted.requestaccess.description": "Нажмите кнопку запроса доступа, и мы найдем того, кто сможет его вам предоставить.",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "У вас нет полномочий для редактирования этой страницы",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "У вас нет полномочий для просмотра этой страницы",
  "confluence.user.profile.department": "Отдел",
  "confluence.user.profile.location": "Место нахождения",
  "confluence.user.profile.position": "Должность",
  "connect.addon.wait.or": "Подождите или",
  "content.empty": "Текст комментария пустой. Нельзя создать пустой комментарий.",
  "content.kind.decisions": "Decision",
  "content.kind.file-list": "File list",
  "content.kind.jirareport": "Jira report",
  "content.kind.kb-how-to-article": "How to article",
  "content.kind.kb-troubleshooting-article": "Troubleshooting article",
  "content.kind.meeting-notes": "Meeting notes",
  "content.kind.product-requirements": "Product requirements",
  "content.kind.retrospective": "Retrospective",
  "content.kind.shared-links": "Shared links",
  "content.kind.task-report": "Task report",
  "content.type.attachment": "Вложения",
  "content.type.blogpost": "Блоги",
  "content.type.page": "Страницы",
  "cq.header.title": "Вопросы",
  "create.blog.post.event.description": "Создать новость",
  "create.drawer.header": "Создание",
  "create.drawer.page.selector.all.pages.in.space": "Все страницы в этом разделе",
  "create.drawer.page.selector.location.header": "Расположение",
  "create.drawer.page.selector.no.page.found": "Страницы не найдены",
  "create.drawer.page.selector.no.parent.page": "Без родительской страницы",
  "create.drawer.page.selector.pages.loading": "Загрузка страниц…",
  "create.drawer.page.selector.parent.page": "Родительская страница",
  "create.drawer.page.selector.parent.page.tooltip.help": "Блоги, календари и вопросы не будут отображаться на родительской странице",
  "create.drawer.page.selector.recent.pages": "Недавние страницы",
  "create.drawer.page.selector.select.parent.page": "Выберите родительскую страницу",
  "create.drawer.space.selector.header": "Раздел",
  "create.drawer.space.selector.location.header": "Расположение",
  "create.drawer.space.selector.no.space.found": "Разделы не найдены",
  "create.drawer.space.selector.recent.spaces": "Недавние разделы",
  "create.drawer.space.selector.search.spaces": "Все разделы",
  "create.drawer.space.selector.select.a.space": "Выберите раздел",
  "create.drawer.space.selector.spaces.loading": "Загрузка разделов…",
  "create.drawer.space.selector.starred.spaces": "Отмеченные разделы",
  "create.drawer.template.failed.to.load.atlassian.support": "Поддержку Atlassian.",
  "create.drawer.template.failed.to.load.content": "Обновите страницу и повторите попытку. Если проблема не исчезнет, обратитесь в",
  "create.drawer.template.failed.to.load.title": "Не удалось загрузить шаблон",
  "create.name": "Создать",
  "css.file": "Файл CSS",
  "current.space": "Текущий раздел",
  "default.space.homepage.title": "{0} Home",
  "delete.name": "Удалить",
  "desc.colourscheme": "Следующие цвета могут быть настроены для цветовой схемы.",
  "description.name": "Описание",
  "discard.name": "Удалить",
  "discover.applications": "Изучайте приложения",
  "draft": "Черновик",
  "draft.no.content": "В этом черновике нет содержимого.",
  "edit.comment": "Редактировать комментарий",
  "edit.labels": "Добавить метки",
  "editor-help.fabric.help.center.feedback.item": "Отзыв",
  "editor.adf.parsing.error.details": "Сведения об ошибке",
  "editor.adf.parsing.error.message.prod": "Обновите страницу и повторите попытку. Если это не решит проблему, обратитесь в <a target=\"_blank\" href=\"{link}\">службу поддержки Atlassian</a>.",
  "editor.adf.parsing.error.message.staging": "Мы уже работаем над этим. А пока вы можете перейти на канал <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> в Slack и обсудить эту проблему.",
  "editor.adf.parsing.error.title.prod": "Не удалось загрузить редактор",
  "editor.adf.parsing.error.title.staging": "Возникла проблема при конвертации этого документа в ADF",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} вложений",
  "editor.attachments.singular": "{0} вложение",
  "editor.attachments.zero": "Вложения",
  "editor.autocomplete.file.header.text": "Предлагаемые файлы",
  "editor.autocomplete.links.create.link": "Вставить ссылку на создаваемую страницу",
  "editor.autocomplete.links.dialog.search": "Поиск  ‘{0}’",
  "editor.autocomplete.links.dialog.search.no.text": "Поиск",
  "editor.autocomplete.links.header.text": "Предлагаемые ссылки",
  "editor.autocomplete.links.web.link": "Вставить Web ссылку",
  "editor.autocomplete.macros.dialog.browse": "Открыть список макросов",
  "editor.autocomplete.macros.error.load.header": "Ошибка при получении описания макроса",
  "editor.autocomplete.macros.error.load.retrylink": "Попробуйте еще раз",
  "editor.autocomplete.macros.header.text": "Предлагаемые Макросы",
  "editor.autocomplete.media.files.dialog.browse": "Открыть список файлов",
  "editor.autocomplete.media.header.text": "Предлагаемые медиа",
  "editor.autocomplete.media.images.dialog.browse": "Открыть список изображений",
  "editor.autocomplete.media.macros.dialog.browse": "Вставьте другой тип мультимедиа",
  "editor.autoformat.sampletext.firstcell": "первая ячейка",
  "editor.autoformat.sampletext.heading": "заголовок",
  "editor.buttons.disable.by.empty.title.tooltip": "Вашу страницу надо озаглавить перед публикацией.",
  "editor.buttons.disable.by.not.saving.tooltip": "Выполнение…",
  "editor.buttons.disable.by.saving.tooltip": "Выполняется сохранение страницы.",
  "editor.cancel.discard.changes.confirmation": "Отменить изменения",
  "editor.cancel.discard.changes.message": "Весь введенный контент будет отменен. Пожалуйста, подтвердите.",
  "editor.cancel.discard.changes.title": "Подтвердить отмену всех изменений",
  "editor.cant.publish.changes": "Нельзя опубликовать изменения",
  "editor.change.comment": "Что вы изменили?",
  "editor.close.publish.tooltip": "Сохранить изменения без публикации",
  "editor.close.update.tooltip": "Сохранить изменения без обновления",
  "editor.collab.user.limit.body": "Эта страница очень популярна, достигнуто максимальное число единовременных редакторов. Повторите попытку, когда она не будет так занята.",
  "editor.collab.user.limit.title": "В данный момент вы не можете редактировать эту страницу.",
  "editor.collaborative-editing.load.error": "Загрузка редактора занимает больше времени, чем обычно. Подождите еще немного и затем перезагрузите страницу, если он не загрузится. Если это не исправит ситуацию, поговорите с администратором Confluence.",
  "editor.collaborative-editing.refresh-editor.error": "При загрузке редактора что-то пошло не так, попробуйте еще раз.",
  "editor.collaborative.mode.disabled": "В данный момент совместное редактирование не работает. Скопируйте свою работу и перезагрузите страницу, чтобы продолжить редактирование.",
  "editor.collaborative.mode.enabled": "Совместное редактирование было отключено, но теперь оно снова работает. Скопируйте свои изменения и обновите страницу, чтобы продолжить редактирование.",
  "editor.content.appearance.toggle.fixed.width": "Открывать страницу в полную ширину",
  "editor.content.appearance.toggle.full.width": "Установить фиксированную ширину страницы",
  "editor.content.placeholder.11": "На эту страницу можно добавить различную информацию, например оглавление, дату или дорожную карту. Чтобы открыть список доступных возможностей, нажмите /.",
  "editor.content.placeholder.ai": "Введите «/ai» для вызова Atlassian Intelligence, «/» для добавления элементов или «@», чтобы упомянуть пользователя (он получит уведомление).",
  "editor.content.placeholder.bpqa": "Введите «/», чтобы просмотреть список элементов, «@», чтобы упомянуть пользователя, или выберите один из вариантов ниже:",
  "editor.content.placeholder.bpqa.ai": "Введите «/ai» для вызова Atlassian Intelligence, «/» для добавления элементов, «@», чтобы упомянуть пользователя, или выберите один из вариантов ниже:",
  "editor.content.placeholder.easy.mentions": "Введите «/», чтобы просмотреть все элементы, или «@», чтобы упомянуть пользователя.",
  "editor.content.placeholder.slash": "Чтобы вставить элемент, введите /",
  "editor.content.placeholder.slash.bracket": "Можно быстро вставить любой элемент с помощью /",
  "editor.content.reconciliation.error.details": "Информация об ошибке:",
  "editor.content.reconciliation.error.fatal.prod": "Мы уже работаем над этим. Повторите попытку через несколько минут. Если проблема не исчезнет, обратитесь в Поддержку Atlassian.",
  "editor.content.reconciliation.error.fatal.staging": "Мы уже работаем над этим. А пока вы можете зайти на канал #cc-content-experience в Slack и обсудить эту проблему.",
  "editor.content.reconciliation.error.retrying": "Повторная попытка через {0}…",
  "editor.content.reconciliation.error.title": "Не удалось загрузить страницу",
  "editor.content.reconciliation.networkerror.fatal.prod": "Обновление страницы должно помочь. Если проблему решить не удастся, свяжитесь со <a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">службой поддержки Atlassian</a> или администратором вашего раздела.",
  "editor.content.reconciliation.networkerror.title": "Не удается загрузить ваше содержимое",
  "editor.discard-on-close.tooltip": "Удалить пустой черновик",
  "editor.discard-to-published.button.label": "Выбросить",
  "editor.discard-to-published.button.tooltip": "Вернуться к последней опубликованной версии страницы",
  "editor.discard-to-published.dialog.title": "Сбросить неопубликованные изменения?",
  "editor.discard-to-published.dialog.warning": "Это вернет редактор к последней опубликованной версии данной страницы. Если кто-либо еще имеет неопубликованные изменения на странице, вы отмените эти изменения тоже.",
  "editor.discard-to-published.error.message": "В настоящее время мы не можем получить последнюю опубликованную версию страницы. Подождите немного, затем попытайтесь отменить черновик снова.",
  "editor.discard-to-published.error.title": "Невозможно вернуться к последней опубликованной версии",
  "editor.discard-to-published.success.message": "Успешно возвращено к последней опубликованной версии",
  "editor.draft.can.be.migrated": "Совместное редактирование здесь! Чтобы вы могли продолжить работу на этой странице, нам нужно переместить содержимое для вас в новый черновик.<br> <a href={0}>Переместить сейчас</a>",
  "editor.dynamic-macro.preview.limit.desc": "Предварительный просмотр динамического макроса в черновом режиме поддерживается только при включенном совместном проекте.",
  "editor.ellipsis.blog.delete": "Удалить неопубликованное сообщение в блоге",
  "editor.ellipsis.import-document": "Открыть шаблон и импортировать документ",
  "editor.ellipsis.open.template.browser": "Открыть просмотр шаблонов",
  "editor.ellipsis.open.templates.and.import": "Шаблоны и документы для импорта",
  "editor.ellipsis.page.delete": "Удалить неопубликованную страницу",
  "editor.ellipsis.remove": "Вернуться к последней опубликованной версии",
  "editor.ellipsis.resolved.comments": "Решенные комментарии",
  "editor.ellipsis.view-changes": "Посмотреть изменения",
  "editor.error.delayed.publishing": "Мы продолжим попытки выполнить публикацию. Если это занимает слишком много времени, обновите страницу и нажмите <strong>Publish</strong> (Опубликовать).",
  "editor.error.delayed.publishing.title": "Ошибка при публикации контента.",
  "editor.excerpt.include.macro.error": "При загрузке отрывка из «{0}» произошла ошибка.",
  "editor.excerpt.panel.title.loading": "Загрузка…",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "Запись в блоге без названия",
  "editor.fabric.share.invite.to.edit.empty.page.title": "Страница без названия",
  "editor.fabric.share.invite.to.edit.form.title": "Предложите кому-нибудь отредактировать эту страницу",
  "editor.files.may.be.uploading": "Возможно, некоторые файлы еще загружаются. Подождите немного и попробуйте снова. В случае неудачи обновите страницу и повторно загрузите все файлы, которые оказались поврежденными перед публикацией.",
  "editor.generic.refresh": "Что-то пошло не так с редактором. Скопируйте ваши несохраненные изменения и обновите страницу для продолжения редактирования.",
  "editor.go.back": "Вернуться назад",
  "editor.heartbeat.unauthorised.warning.generic.body": "Содержание было перемещено, ограничено или удалено. Рекомендуем скопировать все необходимое и закрыть редактор.",
  "editor.heartbeat.unauthorised.warning.generic.title": "Нет доступа к этой странице",
  "editor.heartbeat.unauthorised.warning.page-move.body": "Публикация невозможна из-за того, что страница была перемещена или изменения были ограничены. Мы рекомендуем вам скопировать все, что вам нужно, и закрыть редактор.",
  "editor.heartbeat.unauthorised.warning.page-move.title": "Разрешения страницы были изменены",
  "editor.help.how.to.use.blueprint": "Как использовать {blueprintType}",
  "editor.help.templates": "Использовать шаблоны страниц",
  "editor.help.updates": "Изменения в интерфейсе редактирования",
  "editor.help.updates.1.description": "Публикаций в блогах коснулся первый этап обновления интерфейса редактирования. Адаптивный контент, улучшенная обработка изображений и более удобный интерфейс. Создайте новую публикацию в блоге, чтобы убедиться самостоятельно.",
  "editor.help.updates.1.title": "Публикации в блоге",
  "editor.help.updates.2.description": "Запущен новый интерфейс для редактирования записок по совещанию. В числе последних обновлений — расширенные возможности работы с таблицами, доступные по нажатию на таблицу. Кроме того, повышены стабильность и быстродействие.",
  "editor.help.updates.2.title": "Записки по совещанию",
  "editor.hints.close": "Закрыть подсказки",
  "editor.hints.next": "Следующая подсказка",
  "editor.labels": "{0}",
  "editor.labels.desc": "Редактировать метки страницы",
  "editor.labels.plural": "{0} метки",
  "editor.labels.singular": "{0} Метка",
  "editor.labels.zero": "Метки",
  "editor.learn.more": "Узнайте больше",
  "editor.location.desc": "Добавить местоположение",
  "editor.minor.edit": "Сообщить наблюдателям",
  "editor.offline.before.save.error": "Сервер не доступен. Сохранение сейчас невозможно.",
  "editor.offline.preview.error": "Невозможно связаться с сервером. Проверьте наличие подключения к Интернету и находится ли Confluence в рабочем состоянии.",
  "editor.offline.save.error": "Не могу связаться с сервером. Сохранение в текущий момент невозможно.",
  "editor.offline.save.error.generic": "При обработке запроса произошла ошибка.",
  "editor.offline.save.noauthorized": "Сеанс завершен. Чтобы продолжить работу, снова войдите в систему или смените аккаунт. \n <div><a href=\"/login?application=confluence\">Войти или сменить аккаунт</a></div>",
  "editor.offline.save.noauthorized.title": "Невозможно подключиться к серверу",
  "editor.offline.save.page.exist.content": "В этом разделе уже существует страница с заголовком «'{'0'}'». Введите другой заголовок страницы.",
  "editor.onboarding.draft.placeholder": "Введите «/» для просмотра списка полезных элементов, которые можно добавить на страницу, таких как оглавление или дорожная карта.<br/>Или, если у вас совсем нет идей, начните с одного из шаблонов справа →",
  "editor.onboarding.spotlight.body": "Узнайте, что изменилось и почему.",
  "editor.onboarding.spotlight.finish": "Понятно",
  "editor.onboarding.spotlight.title": "Мы обновляем шаблоны по одному",
  "editor.onboarding.step1.content": "Мы работаем, чтобы предоставить запрашиваемые вами функции, начиная с улучшения легкости чтения, умных инструментов форматирования и более современного вида. <br /><a href=''{linkCAC}' target='_blank'>Узнайте больше об изменениях</a>",
  "editor.onboarding.step1.title": "Более дружелюбные сообщения в блоге",
  "editor.onboarding.step2.content": "Наиболее используемые вами функции находятся на панели инструментов, а более продвинутые инструменты – под знаком «Плюс». У вас также есть куча новых эмотиконов для улучшения настроения! <br/><a href=''{linkCAC}' target='_blank'>Узнайте больше об изменениях</a>",
  "editor.onboarding.step2.title": "Вы в поисках чего-то?",
  "editor.onboarding.step3.content": "Эта работа не закончена, и мы нуждаемся в вашей помощи, чтобы сделать ее потрясающей. Отправьте нам свой отзыв и следите за <a href=''{linkCAC}' target='_blank'>страницей Confluence,</a> чтобы быть в курсе последних изменений. <br/><a href=''{linkCAC}' target='_blank'>Узнайте больше об изменениях</a>",
  "editor.onboarding.step3.title": "Давайте вместе создадим что-нибудь важное",
  "editor.page.can.not.be.accessed.message": "Похоже, сеанс завершен. Чтобы продолжить работу, снова войдите в систему или смените аккаунт. \n <div><a href=\"/login?application=confluence\">Войти или сменить аккаунт</a></div>",
  "editor.page.can.not.be.accessed.title": "Данное содержимое недоступно.",
  "editor.page.conflict.message": "Обновите страницу, чтобы попытаться восстановить соединение.",
  "editor.page.conflict.title": "Невозможно синхронизироваться с сервером.",
  "editor.page.is.too.big": "Эта страница слишком большая для сохранения. Ее можно разделить на несколько страниц, а затем использовать <a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">макрос включения страницы</a> для отображения содержимого.",
  "editor.page.is.trashed.message": "Скопируйте ваш контент, затем добавьте его на новую страницу, или <div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">восстановите эту страницу из корзины</a> и попытайтесь снова.</div>",
  "editor.page.is.trashed.title": "Это содержимое было удалено",
  "editor.page.legacy.draft.deprecated": "Совместное редактирование здесь! Это значит, что нам нужно, чтобы вы нам немного помогли, чтобы перезапустить вашу сессию редактирования. Все что вам нужно сделать, это скопировать содержимое, снова отредактировать эту страницу, затем вставить его и сохранить.",
  "editor.page.moved.message.body": "Все в порядке - вы все равно сможете опубликовать свои изменения, когда будете готовы. <br /><br /> Новое местоположение: {0}",
  "editor.page.moved.message.title": "{0} переместил эту страницу",
  "editor.page.moved.message.unknown.mover": "Другой пользователь",
  "editor.placeholder.broken.image": "Повреждённый файл изображения",
  "editor.placeholder.broken.link": "Повреждённая ссылка",
  "editor.placeholder.broken.macro": "Повреждённый макрос",
  "editor.placeholder.error": "Ошибка",
  "editor.preview.error": "Возникла ошибка при загрузке предварительного просмотра. Пожалуйста, повторите попытку позже.",
  "editor.publish.blog": "Публиковать",
  "editor.publish.blog.desc": "Опубликовать ваш ответ в блог",
  "editor.publish.external.share.label": "Внешний общий доступ",
  "editor.publish.hotkey.description": "Чтобы опубликовать этот контент, нажмите {keyCombination}.",
  "editor.publish.with.comment": "Опубликовать с комментарием к версии...",
  "editor.publish.without.notify": "Опубликовать, не уведомляя наблюдателей",
  "editor.quit-dialog.button.delete.blog.exit": "Удалить сообщение в блоге",
  "editor.quit-dialog.button.delete.page.exit": "Удалить страницу",
  "editor.quit-dialog.button.discard.changes.by.many": "Удалить изменения <strong>всех</strong>",
  "editor.quit-dialog.button.discard.changes.by.one": "Сбросить <strong>все</strong> изменения",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "Отменить все неопубликованные изменения",
  "editor.quit-dialog.button.discard.limited.tooltip": "Совместное редактирование отключено. Вы можете отменить изменения, когда оно снова будет включено.",
  "editor.quit-dialog.button.revert.blog.exit": "Вернуть сообщение в блоге",
  "editor.quit-dialog.button.revert.page.exit": "Вернуть страницу",
  "editor.quit-dialog.button.save.exit": "Оставить черновик",
  "editor.quit-dialog.cancel.changes.by.many": "<p>Есть внесенные вами и другими людьми изменения, которые еще не были опубликованы. </p><p> Если вы отмените изменения, вы удалить изменения, сделанные отслеживающими людьми и вернетесь к последней опубликованной версии этой страницы.\nОни не смогут восстановить свою работу, если вы сделаете это. </p><p> Эти люди внесли изменения:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p> Вы внесли изменения, которые еще не были опубликованы. </p><p> Если вы отмените изменения, неопубликованные изменения будут удалены. Это действие невозможно отменить. </p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "Это сообщение в блоге, над которым работали вы и другие люди, будет удалено навсегда.",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "Как только вы удалите неопубликованное сообщение в блоге, оно будет удалено навсегда.",
  "editor.quit-dialog.delete.page.changes.by.many": "Это действие навсегда удалит эту страницу, над которой работали вы и другие люди.",
  "editor.quit-dialog.delete.page.changes.by.one": "Как только вы удалите неопубликованную страницу, она будет удалена навсегда.",
  "editor.quit-dialog.last.edited": "Последнее редактирование",
  "editor.quit-dialog.link.hide.diff": "Скрыть изменения",
  "editor.quit-dialog.link.show.diff": "Показать изменения",
  "editor.quit-dialog.publish.changes": "<p>Есть внесенные вами и другими людьми изменения, которые еще не были опубликованы. </p><p> Эти люди внесли изменения:</p>",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "Это действие навсегда удалит все изменения, внесенные вами после последней публикации этого сообщения в блоге.",
  "editor.quit-dialog.revert.changes.by.many": "Это действие навсегда удалит все изменения, внесенные теми, кто работал над страницей с момента ее последней публикации.",
  "editor.quit-dialog.revert.page.changes.by.one": "Это действие навсегда удалит все изменения, внесенные вами после последней публикации этой страницы.",
  "editor.quit-dialog.title.blogpost.delete": "Удалить неопубликованное сообщение в блоге?",
  "editor.quit-dialog.title.discard": "Вернуться к последней опубликованной версии?",
  "editor.quit-dialog.title.exit": "Закрыть редактор",
  "editor.quit-dialog.title.page.delete": "Удалить неопубликованную страницу?",
  "editor.quit-dialog.title.publish": "Опубликовать все изменения?",
  "editor.restrictions.desc": "Изменение ограничений страницы",
  "editor.return.to.edit": "Вернуться в режим редактирования",
  "editor.satisfaction.survey.description": "Что вы думаете о процедуре редактирования?",
  "editor.satisfaction.survey.final.description": "Ваш отзыв представлен на рассмотрение",
  "editor.satisfaction.survey.final.title": "Спасибо",
  "editor.satisfaction.survey.question.bad": "Жаль это слышать. Что пошло не так? (опционально)",
  "editor.satisfaction.survey.question.good": "Спасибо! Что вам понравилось? Что можно улучшить? (опционально)",
  "editor.satisfaction.survey.title": "Ваша страница опубликована",
  "editor.save.draft.desc": "Сохранить Ваш черновик",
  "editor.save.page.desc": "Сохранить Вашу страницу",
  "editor.shared.draft.done.desc": "Сохранить черновик. Если он пустой — удалить его.",
  "editor.shared.draft.publish.desc": "Опубликовать изменения",
  "editor.shared.draft.update.desc": "Обновить опубликованную страницу",
  "editor.shortcuts": "Редактирование комбинации клавиш",
  "editor.synchrony.publish-page.message": "{0} опубликовал эту страницу.",
  "editor.template.changing.variable.dialog.title": "Редактировать переменную шаблона",
  "editor.template.variable.input.creation.error.action": "Обратитесь в службу поддержки Atlassian",
  "editor.template.variable.input.creation.error.description": "Обновите страницу и повторите попытку. Если проблема не исчезнет, сообщите нам об этом, перейдя по ссылке ниже.",
  "editor.template.variable.input.creation.error.title": "Произошла ошибка",
  "editor.template.variable.list.field.placeholder": "опция 1, опция 2, опция 3",
  "editor.template.variable.name.field": "Имя переменной",
  "editor.title.is.empty": "Добавьте название страницы перед публикацией.",
  "editor.title.is.empty.title": "Этой странице нужно название",
  "editor.title.placeholder": "Заголовок страницы",
  "editor.title.too.long": "Длина названия не может превышать 255 символов.",
  "editor.unavailable.generic.body": "Сейчас редактирование недоступно. Повторите попытку через несколько минут.",
  "editor.unavailable.title": "Невозможно редактировать",
  "editor.unpublished.changes.lozenge.label": "Неопубликовано",
  "editor.unpublished.changes.lozenge.tooltip": "На этой странице есть неопубликованные изменения",
  "editor.waiting.to.publish.changes": "Возможно, загрузка файла все еще выполняется.",
  "editor.waiting.to.publish.changes.title": "Подождите. Это займет некоторое время.",
  "email.text.added.by": "Добавил",
  "error.connection.lost.body": "Ждем вашего переподключения.",
  "error.connection.lost.title": "Похоже, соединение потеряно.",
  "error.connection.recovered.action": "Перезагрузить содержимое",
  "error.connection.recovered.title": "Соединение восстановлено",
  "error.notfound.title": "О нет, мы не можем найти эту страницу!",
  "error.recovery.body": "Ваши изменения сохранились. Обновите страницу и повторите попытку.",
  "error.recovery.title": "Не удалось загрузить редактор",
  "error.server-error.body": "Попробуйте снова позднее.",
  "error.server-error.title": "Что-то пошло не так.",
  "error.session.expired.body": "В следующий раз будем держаться крепче, честное слово.",
  "error.session.expired.title": "Похоже, сеанс прерван.",
  "excel.file": "Microsoft Excel таблицы",
  "excel.macro.file": "Microsoft Excel таблицы с поддержкой макросов",
  "excel.template.file": "Шаблон Microsoft Excel",
  "excel97.file": "Microsoft Excel лист",
  "excel97.template.file": "Microsoft Excel 97 шаблон",
  "existing.blogpost.placeholder": "Заголовок публикации в блоге",
  "expand-macro.default-title": "Нажмите здесь для раскрытия...",
  "expand.name": "Развернуть",
  "fabric.editor.announcement.datednotice.main": "С {0} вы сможете пользоваться нашим новым редактором.",
  "fabric.editor.announcement.dismiss": "Закрыть",
  "fabric.editor.announcement.greeting": "Здравствуйте, {0}!",
  "fabric.editor.announcement.initialnotice.main": "Через несколько недель изменится механизм создания контента в Confluence.",
  "fabric.editor.announcement.link.action": "Узнайте обо всех изменениях и новых функциях.",
  "fabric.editor.announcement.rollbacknotice.action": "Прочитайте объявление, чтобы узнать, как открыть существующие страницы в прежнем редакторе.",
  "fabric.editor.announcement.rollbacknotice.main": "Недавно интерфейс вашего редактора был случайно обновлен. Мы вернули прежний вид для ваших страниц.",
  "fabric.editor.announcement.tryit.action": "Испытайте их на новой странице.",
  "fabric.editor.announcement.tryitnotice.main": "Теперь страницы будут выглядеть еще лучше, а вы сможете использовать новые функции, например живые макросы.",
  "fabric.editor.changeboarding.banner.action": "Узнайте о новых возможностях.",
  "fabric.editor.changeboarding.banner.dismiss": "Пропустить",
  "fabric.editor.changeboarding.banner.main": "Здравствуйте, {0}! Мы вносим изменения, чтобы вы могли создавать более привлекательный и доступный контент.",
  "fabric.editor.page.removed.description": "Обновите сейчас.",
  "fabric.editor.page.removed.title": "Страница была недавно заархивирована или удалена",
  "fabric.editor.permission.removed.description": "Разрешения для этой страницы были изменены. Обратитесь за помощью к администратору.",
  "fabric.editor.permission.removed.title": "Невозможно показать эту страницу",
  "fabric.full.width.help.center.dialog.title": "New! Width control",
  "fabric.full.width.help.center.pageElement.details": "<p>Переключатель разворачивает <strong>все элементы страницы</strong> по горизонтали, заполняя свободное пространство, а также переводит отображение содержимого страницы обратно в режим фиксированной ширины.</p>",
  "fabric.full.width.help.center.pageElement.title": "Full-width page toggle",
  "fabric.full.width.help.center.tableElement.details": "<p>Управляет шириной <strong>каждого столбца, таблицы</strong> и большинства <strong>макросов</strong> с помощью параметров отображения по ширине и полной ширине. Кроме того, для конкретных элементов можно настроить отображение в режиме фиксированной ширины.</p>",
  "fabric.full.width.help.center.tableElement.title": "Переключатель отдельных элементов",
  "fabric.help.center.columns.details": "<p>Добавьте на страницу <strong>столбец</strong>. Чтобы переключаться между конфигурациями с двумя и тремя столбцами, воспользуйтесь <strong>всплывающим меню</strong>.</p>",
  "fabric.help.center.columns.title": "Столбцы",
  "fabric.help.center.dialog.title": "Изучите основы",
  "fabric.help.center.imageDisplay.details": "<p>Выберите изображение. Чтобы изменить его размер, используйте <strong>маркеры</strong>. Чтобы изменить выравнивание, откройте <strong>всплывающее меню</strong>.</p>",
  "fabric.help.center.imageDisplay.title": "Показ изображений",
  "fabric.help.center.layouts.details": "<p>Используйте клавиши <kbd>←</kbd> и <kbd>→</kbd>, чтобы изменять внешний вид столбцов, таблиц и макросов.</p><p>Вы можете выбрать <strong>фиксированную ширину</strong> для любых экранов, опцию <strong>по всей ширине</strong> или <strong>промежуточный</strong> вариант.</p>",
  "fabric.help.center.layouts.title": "Макеты",
  "fabric.help.center.menuitem.title": "Руководство",
  "fabric.help.center.slashCommands.details": "<p>Нажмите <kbd>/</kbd>, чтобы открыть меню, с помощью которого можно добавить контент на страницу: <strong>таблицы</strong>, <strong>макросы</strong> и <strong>даты</strong>.</p>",
  "fabric.help.center.slashCommands.title": "Команды /",
  "fabric.help.center.spotlight.body": "Вы можете снова посмотреть руководство в любое время.",
  "fabric.help.center.spotlight.header": "Повторим пройденное?",
  "fabric.help.center.tableManipulation.details": "<p>Чтобы редактировать и форматировать таблицы, перемещайте <strong>границы</strong> или используйте <strong>раскрывающееся</strong> и <strong>всплывающее меню</strong>.</p>",
  "fabric.help.center.tableManipulation.title": "Действия с таблицей",
  "fabric.help.center.templates.details": "<p>Найдите подходящий вам шаблон. Чтобы повторно открыть закрытую панель, обратитесь к меню «Дополнительные действия» (•••).</p>",
  "fabric.help.center.templates.title": "Шаблоны",
  "fabric.help.center.title": "Изучите основы",
  "fabric.insert.external.image": "Вставить изображение из Интернета",
  "fabric.template.can.not.parse.content": "Не удалось открыть шаблон, поскольку в нем содержатся поврежденные или неподдерживаемые элементы.",
  "fabric.template.can.not.save.error.title": "Не удалось сохранить изменения",
  "fabric.template.can.not.save.error.title.duplicate": " Шаблон с названием <strong>{0}</strong> уже существует. Укажите другое название, чтобы сохранить шаблон.",
  "fabric.template.found.invalid.node": "Несколько переменных шаблона с одинаковым именем «{variableNames}», но разными параметрами.",
  "favourite.spaces": "Мои разделы",
  "feedback.flag.thanks.description": "Ваши отзывы помогают нам совершенствовать наш продукт.",
  "feedback.flag.thanks.title": "Спасибо!",
  "filter.name": "Фильтр",
  "gif.file": "GIF Файл",
  "global.spaces": "Разделы сайта",
  "globaladminbilling.label": "Биллинг",
  "header.or.footer.unsupported.macros.list": "Следующий макрос в данный момент не поддерживается в {0}:",
  "header.or.footer.unsupported.macros.title": "Неподдерживаемый макрос",
  "heading.comment": "Изменено",
  "heading.createpage": "Создать Страницу",
  "heading.createpage.sentence": "Создать страницу",
  "heading.operations": "Действия",
  "heading.version.date": "Опубликовано",
  "heading.version.number": "Версия",
  "help.name": "Помощь",
  "help.us.improve": "Помогите нам улучшить",
  "hipchat.presence.status.available": "Доступно",
  "hipchat.presence.status.away": "Отошел",
  "hipchat.presence.status.dnd": "Не беспокоить",
  "hipchat.presence.status.offline": "Не в сети",
  "html.file": "HTML Файл",
  "icon.tooltip.remove": "Удалить",
  "icon.tooltip.undo": "Отмена",
  "image.browser.imageurl.label": "URL-адрес изображения",
  "image.height": "Высота",
  "image.properties.dialog.cancel": "Отмена",
  "image.properties.dialog.heading": "Свойства изображения",
  "image.properties.trigger": "Свойства",
  "image.properties.trigger.tooltip": "Установить дополнительные свойства изображения",
  "inline.comment.sidebar.navigate.next.description": "Следующий встроенный комментарий",
  "inline.comment.sidebar.navigate.previous.description": "Предыдущий встроенный комментарий",
  "inline.comments.GROW-1507.dialog.close.label": "Закрыть",
  "inline.comments.GROW-1507.dialog.content": "Вы уже знакомы со встроенными комментариями?<br>Их можно добавлять к определенным частям документа при рассмотрении.",
  "inline.comments.GROW-1507.dialog.header": "Встроенные комментарии",
  "inline.comments.GROW-1507.dialog.ok.label": "ОK, понятно",
  "inline.comments.GROW-1507.dialog.showme.label": "Показать",
  "inline.comments.GROW-1507.dialog.title": "ПОДСКАЗКА ПО КОММЕНТАРИЯМ",
  "inline.comments.batch.email.view": "Просмотреть комментарий",
  "inline.comments.create.placeholder": "написать комментарий…",
  "inline.comments.create.reply.placeholder": "Ответ",
  "inline.comments.date.friendly.about.one.hour.ago": "1 час назад",
  "inline.comments.date.friendly.about.x.days.ago": "{0} дней назад",
  "inline.comments.date.friendly.about.x.hours.ago": "{0} часов назад",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "только что",
  "inline.comments.date.friendly.one.min.ago": "1 минуту назад",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, one {{0} минуту назад} few {{0} минуты назад} many {{0} минут назад} other {{0} минуты назад}}",
  "inline.comments.date.friendly.yesterday": "Вчера",
  "inline.comments.delete.confirmation.message": "Вы уверены, что хотите удалить этот комментарий?",
  "inline.comments.delete.permission": "Недостаточно полномочий на удаление этого комментария.",
  "inline.comments.delete.reply.confirmation.message": "Действительно удалить этот ответ?",
  "inline.comments.delete.with.reply": "Нельзя удалять встроенные комментарии с ответами.",
  "inline.comments.delete.with.reply.need.reload": "Невозможно удалить комментарий, так как в теме есть новые ответы. Перезагрузите, чтобы увидеть их.",
  "inline.comments.edit.permission": "Недостаточно полномочий на редактирование этого комментария.",
  "inline.comments.editor.lost": "Комментарий будет безвозвратно утерян.",
  "inline.comments.editor.timeout": "Не удалось корректно загрузить редактор. {0}Перезагрузите страницу{1} и попробуйте заново.",
  "inline.comments.expand.replies": "Еще ответы: {0}",
  "inline.comments.fabric.editor.error.cannot.be.empty": "Ваш комментарий пуст. Добавьте отзыв и нажмите «Сохранить».",
  "inline.comments.fabric.editor.error.captcha.check.failed": "Ошибка проверки Captcha",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "Проверка Captcha прошла успешно",
  "inline.comments.fabric.editor.error.create.not.permitted": "Настройки разрешений не позволяют вам создавать комментарии. Если вам нужна такая возможность, обратитесь к вашему администратору.",
  "inline.comments.fabric.editor.error.delete.not.permitted": "Настройки разрешений не позволяют вам удалять комментарии. Если вам нужна такая возможность, обратитесь к вашему администратору.",
  "inline.comments.fabric.editor.error.edit.not.permitted": "Настройки разрешений не позволяют вам редактировать комментарии. Если вам нужна такая возможность, обратитесь к вашему администратору.",
  "inline.comments.fabric.editor.error.invalid.selection": "Невозможно создать комментарий. Выделите уникальный текст, чтобы он бросался в глаза и комментарий был связан с соответствующим содержимым.",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "Настройки разрешений не позволяют вам решать комментарии. Если вам нужна такая возможность, обратитесь к вашему администратору.",
  "inline.comments.fabric.editor.error.unexpected": "При сохранении комментария произошла ошибка. Закройте комментарий или обновите страницу, затем попытайтесь добавить комментарий еще раз.",
  "inline.comments.fabric.editor.error.view.not.permitted": "Настройки прав доступа не позволяют вам просматривать этот комментарий. Если вам нужна такая возможность, обратитесь к вашему администратору.",
  "inline.comments.fabric.inline.button.cancel": "Отменить",
  "inline.comments.fabric.inline.button.save": "Сохранить",
  "inline.comments.fabric.sidebar.loading.error": "Произошла ошибка, закройте окно комментариев и повторите попытку",
  "inline.comments.likes.error": "Невозможно обновить лайки.",
  "inline.comments.likes.like": "Нравится",
  "inline.comments.likes.unlike": "Не нравится",
  "inline.comments.navigation.index.of": "{0} из {1}",
  "inline.comments.notification.email.reopened": "Открыто повторно",
  "inline.comments.notification.email.resolved": "Обработано",
  "inline.comments.notification.email.view": "Просмотреть комментарий",
  "inline.comments.resolve.permission": "Недостаточно полномочий на решение этого комментария.",
  "inline.comments.resolved.dangling.message": "Комментарий считается решенным, т. к. {0} {1} удалил(-а) текст.",
  "inline.comments.resolved.dialog.empty": "На этой странице нет решенных комментариев.",
  "inline.comments.resolved.dialog.message": "Этот комментарий не пропал! Решенные комментарии можно посмотреть в любой момент.",
  "inline.comments.resolved.dialog.show.me": "Показать",
  "inline.comments.resolved.discovery.button.dismiss": "ОK, понятно",
  "inline.comments.resolved.discovery.content": "Хотите еще высказаться? Можно заново открыть комментарий с решением, чтобы продолжить обсуждение.",
  "inline.comments.resolved.menu.show.replies": "Ответов: {0}",
  "inline.comments.resolved.menu.show.reply": "Ответов: {0}",
  "inline.comments.resolved.menu.unresolve": "Открыть заново",
  "inline.comments.resolved.message": "Решено пользователем {0} {1}",
  "inline.comments.resolved.view.menu": "Решенные комментарии",
  "inline.comments.server.edit.error": "Невозможно сохранить изменения. Комментарий мог быть удален.",
  "inline.comments.server.error": "Не удалось выполнить запрос.",
  "inline.comments.server.error.edit.comment": "Невозможно отредактировать этот комментарий. Комментарий мог быть удален.",
  "inline.comments.server.error.edit.reply": "Невозможно отредактировать этот ответ. Ответ мог быть удален.",
  "inline.comments.sidebar.cancel": "Отмена",
  "inline.comments.sidebar.close": "Закрыть",
  "inline.comments.sidebar.comment.empty": "Нельзя сохранить пустой комментарий.",
  "inline.comments.sidebar.delete": "Удалить",
  "inline.comments.sidebar.deleted": "Удалено",
  "inline.comments.sidebar.discard": "Отклонить",
  "inline.comments.sidebar.edit": "Редактировать",
  "inline.comments.sidebar.error.create.comment": "Не удалось добавить встроенный комментарий. Выделенный раздел, возможно, содержит макрос или упоминание пользователя. Выделите простой текст",
  "inline.comments.sidebar.error.delete.generic": "Ошибка при удалении комментария. Подробнее об ошибках см. журналы Confluence.",
  "inline.comments.sidebar.error.delete.unauthorised": "Недостаточно полномочий на удаление комментария.",
  "inline.comments.sidebar.error.empty": "Введите комментарий.",
  "inline.comments.sidebar.error.save.comment": "Не удалось сохранить комментарий",
  "inline.comments.sidebar.error.save.reply": "Не удалось сохранить ответ",
  "inline.comments.sidebar.error.stale": "Содержимое страницы устарело, {0}обновите{1} и попробуйте снова.",
  "inline.comments.sidebar.like": "Нравится",
  "inline.comments.sidebar.pagecomment.success": "Комментарий к странице успешно создан",
  "inline.comments.sidebar.reply": "Ответ",
  "inline.comments.sidebar.resolve": "Обработать",
  "inline.comments.sidebar.resolved": "Обработано",
  "inline.comments.sidebar.save": "Сохранить",
  "inline.comments.sidebar.saved": "Сохранено",
  "inline.comments.sidebar.shortcuts.close.description": "Закрыть встроенный комментарий",
  "inline.comments.sidebar.show.resolved.comment": "Показать решенные комментарии",
  "inline.comments.sidebar.tooltip.close.description": "Закрыть боковую панель (])",
  "inline.comments.sidebar.tooltip.next.ic.description": "Следующий комментарий (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "Предыдущий комментарий (P)",
  "inline.comments.templates.create.a.comment": "<strong>оставил(-а) комментарий</strong> на странице",
  "inline.comments.templates.resolved.a.comment": "<strong>решил(-а)</strong> комментарий",
  "inline.comments.templates.resolved.a.comment.dangling": "на удаленный текст ссылался встроенный комментарий, так что комментарий был <strong>решен</strong>",
  "inline.comments.templates.unresolved.a.comment": "<strong>повторно открыл(-а)</strong> комментарий",
  "inline.comments.unresolved.message": "Повторно открыто пользователем {0} {1}",
  "jar.file": "Архив Java",
  "java.file": "Исходный код Java",
  "jpeg.file": "файл JPEG",
  "js.file": "Файл JavaScript",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "Опция",
  "keyboard.shortcut.shift": "Shift",
  "label.contains.invalid.chars": "<b>{0}</b> Содержит недопустимые символы ({1}).",
  "label.name.is.too.long": "Имя метки должно быть меньше {0} символов.",
  "labels.dialog.shortcut.tip": "Контекстная подсказка: нажатие <b>{shortcut}</b> в режиме просмотра страницы также открывает это диалоговое окно",
  "labels.none": "Нет меток",
  "labels.title": "Метки",
  "last.saved": "Последнее сохранение",
  "likes.bethefirst": "Станьте первыми кому понравится это",
  "likes.follow": "Последовать",
  "likes.following": "За кем следуете Вы",
  "likes.like": "Нравится",
  "likes.peoplewholikethis": "Люди, кому это нравится",
  "likes.summary.1.non-promoted": "{0} нравится это",
  "likes.summary.1.promoted": "{0} нравится это",
  "likes.summary.1.promoted.1.non-promoted": "{0} и {1} нравится это",
  "likes.summary.2.promoted": "{0} и {1} нравится это",
  "likes.summary.2.promoted.1.non-promoted": "{0}, {1} и {2} нравится это",
  "likes.summary.3.promoted": "{0}, {1} и {2} нравится это",
  "likes.summary.3.promoted.1.non-promoted": "{0}, {1}, {2} и {3} нравится это",
  "likes.summary.you": "Вам нравится",
  "likes.summary.you.1.non-promoted": "Вам и {0} нравится это",
  "likes.summary.you.1.promoted": "Вам и {0} нравится это",
  "likes.summary.you.1.promoted.1.non-promoted": "Вам, {0} и {1} нравится это",
  "likes.summary.you.2.promoted": "Вам, {0} и {1} нравится это",
  "likes.summary.you.2.promoted.1.non-promoted": "Вам, {0}, {1} и {2} нравится это",
  "likes.summary.you.3.promoted": "Вам, {0}, {1} и {2} нравится это",
  "likes.summary.you.3.promoted.1.non-promoted": "Вам, {0}, {1}, {2} и {3} нравится это",
  "likes.unlike": "Отменить нравится",
  "limited.mode.existing.editor.body": "Совместное редактирование сейчас недоступно, и {0} редактирует эту страницу. Попробуйте еще раз через несколько минут.",
  "link.browser.advanced.desc1": "Для вставки ссылки на новую страницу, введите желаемый заголовок страницы.",
  "link.browser.advanced.desc2": "Для вставки ссылки-якоря, введите #anchorname.",
  "link.browser.advanced.error.internal.error": "Внутренняя ошибка сервера",
  "link.browser.advanced.error.not.link": "Указанный текст ссылки содержит некорректную разметку",
  "link.browser.advanced.error.unknown.shortcut": "{0} неизвестная ссылка",
  "link.browser.advanced.error.unknown.space": "{0} неизвестный раздел",
  "link.browser.advanced.title": "Здесь Вы можете вставить ссылку на страницу с использованием <a href=\"{0}\" target=\"_blank\">wiki разметки</a>.",
  "link.browser.autocomplete.hint": "Подсказка: нажмите \"[\" в редакторе для просмотра возможных страниц и добавления ссылки.",
  "link.browser.cancel.button": "Отмена",
  "link.browser.edit.button": "Вставить",
  "link.browser.edit.title": "Редактировать ссылку",
  "link.browser.file.attach": "Загрузить файл",
  "link.browser.file.attach.desc": "Ссылаться на файл, который прикреплен к этой странице или прикрепить новый",
  "link.browser.file.attach.upload.in.progress": "Загрузка в процессе...",
  "link.browser.file.browse.button": "Просмотр",
  "link.browser.files.none": "На этой странице нет файлов.",
  "link.browser.insert.button": "Вставить",
  "link.browser.insert.title": "Вставить ссылку",
  "link.browser.link": "Ссылка",
  "link.browser.link.alias": "Текст ссылки",
  "link.browser.link.image.label": "Изображение ссылки",
  "link.browser.location": "Расположение ссылки",
  "link.browser.recently.viewed.load.error": "Ошибка при загрузке недавно просмотренных страниц",
  "link.browser.recently.viewed.none": "Отсутствует недавно просмотренный контент.",
  "link.browser.search": "Поиск",
  "link.browser.search.for": "Искать",
  "link.browser.search.invalid": "Неверные условия поиска",
  "link.browser.search.results.load.error": "Есть ошибки, возникшие в ходе поиска",
  "link.browser.search.results.none": "Нет результатов поиска.",
  "link.browser.space.all": "Всё содержимое",
  "link.browser.tab.name.advanced": "Дополнительно",
  "link.browser.tab.name.files": "Файлы",
  "link.browser.tab.name.recently.viewed": "Часто просматриваемые",
  "link.browser.tab.name.search": "Поиск",
  "link.browser.tab.name.weblinks": "Web ссылка",
  "link.browser.table.file.comment": "Комментарий",
  "link.browser.table.file.name": "Имя",
  "link.browser.table.file.size": "Размер",
  "link.browser.table.last.modified": "Последнее изменение",
  "link.browser.table.space": "Раздел",
  "link.browser.table.title": "Заголовок",
  "link.browser.web.link": "URL страницы проекта",
  "link.browser.web.link.desc": "Веб, email или любой другой интернет-адрес",
  "link.browser.web.link.label": "Адрес",
  "location.name": "Расположение",
  "login.button": "Войти",
  "look.and.feel": "Внешний вид",
  "marketplace.link.name": "Приложения в Marketplace",
  "more.word.action": "Другие действия",
  "more.word.capitalised": "Больше",
  "moveblogpost.already.exists.in.target.space": "В выбранном пространстве уже существует другая публикация блога с таким же заголовком и датой.",
  "moveblogpost.source.notfound": "Исходная публикация в блоге не найдена.",
  "moveblogpost.target.space.notfound": "Целевое пространство не найдено.",
  "moveblogpost.target.space.same.as.origin": "Невозможно переместить публикацию блога в пространство, где она уже находится.",
  "multimedia.file": "Файл мультимедиа",
  "my.drafts.mainBanner": "Страницы для ваших идей",
  "my.drafts.subBanner": "Создайте страницу, на которой будете делиться с миром своими идеями. Если вы еще не готовы сделать публикацию, просто закройте окно. Мы автоматически сохраним черновик, и вы сможете вернуться к нему, когда захотите. ",
  "my.spaces.tooltip.add": "Добавить в список моих разделов",
  "my.spaces.tooltip.remove": "Удалить из списка моих разделов",
  "name.word": "Имя",
  "nav.controller.activity": "Активность",
  "nav.controller.activity.feed": "Лента активности",
  "nav.controller.all.spaces": "Разделы",
  "nav.controller.discover": "Новейшие",
  "nav.controller.my.spaces": "Мои разделы",
  "nav.controller.my.spaces.anchor": "Все",
  "nav.controller.my.spaces.blank": "Держите самые полезные разделы под рукой. Щелкните метку возле любого из разделов, чтобы он отобразился здесь.",
  "nav.controller.my.spaces.blank.callToAction": "Поиск разделов",
  "nav.controller.projects": "Проекты",
  "nav.controller.recent": "Недавние страницы",
  "nav.controller.your.work": "Ваша работа",
  "navigation.app.switcher.apps": "Приложения",
  "navigation.app.switcher.dont.show.again": "Больше не показывать",
  "navigation.app.switcher.edit": "Редактировать",
  "navigation.app.switcher.error-message": "Ошибка при получении ссылок на приложение.",
  "navigation.app.switcher.home.description": "Главная",
  "navigation.app.switcher.img.alt": "Переключатель приложений",
  "navigation.app.switcher.loading": "Загрузка...",
  "navigation.app.switcher.recent": "Недавние",
  "navigation.app.switcher.recent-containers-confluence-space": "Раздел",
  "navigation.app.switcher.recent-containers-jira-project": "Проект",
  "navigation.app.switcher.try.other.apps": "Попробуйте другие приложения",
  "navigation.app.switcher.use.confluence": "Использовать сочетание",
  "navigation.app.switcher.use.jira": "Использовать Jira",
  "navigation.label-for-bell": "Уведомления",
  "navigation.label-for-global-people-icon": "Каталог людей",
  "navigation.notification-drawer-title": "Уведомления Home",
  "navigation.people-drawer-title": "Каталог людей",
  "navlink.edit": "{0}Р{1}едактирование",
  "network.page": "Сетевая  страница",
  "no.drafts.found": "Черновики не найдены.",
  "no.matches.mainBanner": "Не можем ничего найти для",
  "no.name": "Нет",
  "no.permission": "Нет Разрешения",
  "no.spaces.found": "Разделы не найдены.",
  "not.watching.anything": "Вы ни за чем не наблюдаете.",
  "notification.start": "Начать наблюдение",
  "notification.stop": "Остановить наблюдение",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#Встроенный комментарий|1<Встроенные комментарии}",
  "notifications.batch.inline.comment.new.lozenge": "новый",
  "notifications.batch.inline.comment.reopened.lozenge": "заново открыл",
  "notifications.batch.inline.comment.resolved": "Пользователь $user $lozenge комментарий",
  "notifications.batch.inline.comment.resolved.lozenge": "разрешил",
  "notifications.preferences.desc": "Вы можете настроить параметры уведомлений на странице<a href=\"viewmyemailsettings.action\">настройки электронной почты</a> .",
  "onboarding-choose-a-space.description": "Выберите один из разделов команды. Позже вы сможете создать другие разделы.",
  "onboarding-choose-a-space.title": "Выбор раздела",
  "onboarding.choose-a-space.backBtn": "Назад",
  "onboarding.choose-a-space.nextBtn": "Далее",
  "onboarding.choose-a-space.selectLabel": "Имя раздела",
  "onboarding.choose-a-space.selectPlaceholder": "Выберите название раздела",
  "onboarding.create-a-space.backBtn": "Назад",
  "onboarding.create-a-space.description": "Начните с создания раздела для текущей команды или проекта. Позже вы сможете создать другие разделы.",
  "onboarding.create-a-space.inputTextLabel": "Название",
  "onboarding.create-a-space.inputTextPlaceholder": "Кристаллы",
  "onboarding.create-a-space.invalidMessage": "Имя раздела должно состоять как минимум из одной буквы или цифры.",
  "onboarding.create-a-space.nextBtn": "Далее",
  "onboarding.create-a-space.title": "Новый раздел",
  "onboarding.dialog.existing-user.cancel": "Не показывать подсказки",
  "onboarding.dialog.existing-user.confirm": "Вперед",
  "onboarding.dialog.existing-user.content": "Мы переместили некоторые элементы ради удобства использования панели инструментов, а также включили подсказки, которые помогут вам освоиться.",
  "onboarding.dialog.existing-user.title": "Добро пожаловать в новую панель инструментов!",
  "onboarding.dialog.new-user.cancel": "Не показывать подсказки",
  "onboarding.dialog.new-user.confirm": "Вперед",
  "onboarding.dialog.new-user.content": "Панель инструментов — это стартовая страница, помогающая освоиться в Confluence.<br/>Для облегчения знакомства включены некоторые подсказки",
  "onboarding.dialog.new-user.title": "Добро пожаловать в панель инструментов!",
  "onboarding.navigation.blog.tip.blog.list.byline": "Нажмите на кнопку «главная» для переключения на список страниц или прочее содержимое.",
  "onboarding.navigation.blog.tip.blog.list.heading": "Ваш список блогов все еще можно найти здесь",
  "onboarding.navigation.dont.show": "Больше не показывать мне советов",
  "onboarding.navigation.global.sidebar.byline": "Так что не имеет значения, где в Confluence вы находитесь, важно то, что вы всего в одном нажатии.",
  "onboarding.navigation.global.sidebar.heading": "Эта боковая панель теперь является универсальной",
  "onboarding.navigation.ok": "Хорошо, мне понятно",
  "onboarding.navigation.page.tip.page.tree.byline": "Нажмите на кнопку «главная» для переключения на список блогов или прочее содержимое.",
  "onboarding.navigation.page.tip.page.tree.heading": "Древо структуры вашей страницы все еще можно найти здесь",
  "onboarding.navigation.space.tip.space.tabs.byline": "Домашняя страница вашего раздела теперь является кратким обзором, и у ваших страниц, постов в блогах и другого контента есть своя собственная вкладка.",
  "onboarding.navigation.space.tip.space.tabs.heading": "Ваш контент теперь разделен на вкладки",
  "onboarding.tooltip.actions.done": "Понятно!",
  "onboarding.tooltip.actions.next": "Далее",
  "onboarding.tooltip.actions.skip": "Пропустить подсказки",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "Переходите непосредственно к избранным разделам или к списку всех разделов.",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "Избранные разделы под рукой",
  "onboarding.tooltip.existing-user.sidebar.content": "Находите новые страницы и возвращайтесь к недавним операциям с помощью новой удобной боковой панели.",
  "onboarding.tooltip.existing-user.sidebar.title": "Больше возможностей с боковой панелью",
  "onboarding.tooltip.new-user.favourite-spaces.content": "Переходите непосредственно к избранным разделам или к списку всех разделов.",
  "onboarding.tooltip.new-user.favourite-spaces.title": "Избранные разделы под рукой",
  "onboarding.tooltip.new-user.sidebar.content": "Находите новые страницы и возвращайтесь к недавним операциям с помощью боковой панели.",
  "onboarding.tooltip.new-user.sidebar.title": "Больше возможностей с боковой панелью",
  "onboarding.tooltip.saved-for-later.content": "Избранные страницы теперь отображаются под новым именем — «Сохранено на будущее».",
  "onboarding.tooltip.saved-for-later.title": "Прощай, «Избранное»! Да здравствует «Сохранено на будущее»!",
  "onboarding.who-is-on-your-team.addMoreBtn": "Добавить другие адреса",
  "onboarding.who-is-on-your-team.description": "Основные достоинства Confluence раскрываются, когда вы работаете в связке с другими участниками команды и обсуждаете свой прогресс.",
  "onboarding.who-is-on-your-team.emailPlaceholder": "Добавить адрес электронной почты",
  "onboarding.who-is-on-your-team.enableDRS": "Разрешить пользователям с подтвержденным адресом электронной почты {domain} присоединяться к вашему сайту (в таких случаях мы будем отправлять вам уведомления)",
  "onboarding.who-is-on-your-team.enableOpenInvite": "Разрешить пользователям приглашать на сайт других людей",
  "onboarding.who-is-on-your-team.form.invalid.email": "Введите действительный адрес электронной почты",
  "onboarding.who-is-on-your-team.nextBtn": "Далее",
  "onboarding.who-is-on-your-team.title": "Пригласите участников",
  "only.personal.labels.permitted": "Вам разрешено только добавлять персональные метки на этой странице.",
  "org.randombits.confluence.toc.toc.label": "Оглавление",
  "page.already.exists": "В выбранном разделе уже существует страница с таким заголовком.",
  "page.already.exists.inspace": "В разделе «'{'1'}'» уже существует страница «'{'0'}'». Прежде чем переместить страницу, необходимо изменить ее заголовок.",
  "page.change": "Что вы изменили?",
  "page.comments.saved.dialog.message": "Комментарий был сохранен в виде комментария к странице.",
  "page.comments.sidebar.warning": "Невозможно добавить встроенный комментарий к данному контенту. Вместо этого мы добавим его как комментарий к странице.",
  "page.descendent.already.exists": "Подчиненная страница имеет тот же заголовок, что и другая страница из выбранного раздела.",
  "page.permissions.menu.item.title": "Ограничения",
  "page.permissions.menu.item.title.tooltip": "Изменить ограничения",
  "page.tree.blankExperience.mainBanner": "Здесь ничего нет — кроме потенциала.",
  "page.tree.blankExperience.subBanner": "Создавайте заметки, требования к ПО, обучающие статьи и другие тексты, чтобы наполнить этот раздел.",
  "page.watch.instruction": "Для наблюдения за страницей или блогом: откройте меню ‘Инструменты’ и кликните ‘Наблюдать’.",
  "page.watches": "страница наблюдателей",
  "page.word": "Страница",
  "pages.navigation.discovery.body.html": "Нажмите на <strong>Страницы</strong>, чтобы посмотреть дерево страниц и увидеть страницы в этом пространстве.",
  "pages.navigation.discovery.header": "Теперь здесь находится дерево страниц",
  "pages.show.all": "Все страницы",
  "pages.word": "Страницы",
  "pagetree.dragndrop.failed.action.visitsupport": "Служба поддержки Atlassian",
  "pagetree.dragndrop.failed.description": "Обновите страницу и повторите попытку. Если проблема не исчезнет, сообщите нам об этом, нажав на ссылку ниже.",
  "pagetree.dragndrop.failed.title": "Произошла ошибка",
  "pagetree.failed.load.content": "Не удалось загрузить дерево страниц",
  "pagetree.failed.load.tooltip": "Мы уже работаем над устранением неполадки.",
  "parent.page.invalid.for.space": "Нет страницы с таким заголовком <b>{0}</b> в разделе <b>{1}</b>.",
  "parent.page.name": "Родительская страница",
  "pdf.file": "PDF Файл",
  "people.directory.name": "Пользователи",
  "period.lastSevenDays": "За прошлую неделю",
  "period.lastThirtyDays": "За прошлый месяц",
  "period.older": "Более месяца назад",
  "period.today": "Сегодня",
  "period.yesterday": "Вчера",
  "permission.owner.not.in.group": "Вы можете предоставить разрешения на страницу только для групп, членами которых Вы являетесь.",
  "permission.owner.not.set": "Вы должны выбрать собственника для разрешений",
  "permissions.comment": "Установите кто может просматривать и редактировать страницу. Вы можете ограничить разрешения для себя или группы пользователей.",
  "permissions.edit.title": "Редактирование",
  "permissions.select.nopermissions": "Не установлено",
  "permissions.view.title": "Просмотр",
  "person.follow": "Последовать",
  "person.follow.stop": "Остановить следование",
  "personal.spaces": "Личные разделы",
  "placeholder.placeholdertext.label": "Текст заполнителя",
  "placeholder.replacementtext.label": "Текст замены",
  "please.enter.a.label": "пожалуйста, введите метку.",
  "png.file": "PNG-файл",
  "popular.stream.mainBanner": "Пока что здесь тихо...",
  "popular.stream.subBanner": "Тут пока тишь да гладь, но как только ваша команда приступит к наполнению сайта, здесь будут представлены самые популярные страницы и файлы.",
  "popular.stream.subBanner2": "Ну что, поехали?",
  "popular.stream.title": "Популярное",
  "posted.word": "Опубликовано",
  "powerpoint.file": "Презентация Microsoft PowerPoint",
  "powerpoint.macro.file": "Презентация Microsoft Powerpoint с поддержкой макросов",
  "powerpoint.slideshow.file": "Microsoft Powerpoint Слайд-шоу",
  "powerpoint.template.file": "Microsoft Powerpoint шаблон",
  "powerpoint97.file": "Microsoft PowerPoint 97 Слайд-шоу",
  "powerpoint97.template.file": "Microsoft PowerPoint 97 шаблон",
  "product.name": "Confluence",
  "profile.page": "Страница профиля",
  "property.panel.macro.display.inline": "Отобразить внутри строки",
  "property.panel.macro.display.newline": "Отобразить на новой строке",
  "property.panel.macro.edit": "Изменить",
  "property.panel.macro.remove": "Удалить",
  "property.panel.textplaceholder.display.default": "Текст",
  "property.panel.textplaceholder.display.default.tooltip": "Текст инструкции заменяется пустым содержимым по мере ввода.",
  "property.panel.textplaceholder.display.mention": "Указание пользователя",
  "property.panel.textplaceholder.display.mention.tooltip": "Текст инструкции заменяется предлагаемыми именами пользователей по мере ввода.",
  "property.panel.textplaceholder.remove": "Удалить",
  "property.panel.variable.display.list": "Список",
  "property.panel.variable.display.list.tooltip": "Выпадающий список.",
  "property.panel.variable.display.string": "Текст",
  "property.panel.variable.display.string.tooltip": "Однострочное текстовое поле.",
  "property.panel.variable.display.textarea": "Многострочный текст",
  "property.panel.variable.display.textarea.tooltip": "Многострочное текстовое поле.",
  "property.panel.variable.list.values.tooltip": "Укажите все элементы списка, разделяя их запятыми.",
  "property.panel.variable.textarea.columns.tooltip": "Количество столбцов, отображаемых для поля.",
  "property.panel.variable.textarea.rows.tooltip": "Количество строк, отображаемых для поля.",
  "quick.comment.placeholder.message": "Написать комментарий...",
  "quick.reload.edit": "Новые правки",
  "quick.reload.edit.by": "кем:",
  "quick.reload.edit.more": "и {0} других",
  "quick.reload.edit.one.more": "и ещё 1",
  "quick.reload.edits": "{0} новых правок",
  "quick.reload.newcomments": "{0} новые комментарии",
  "quick.reload.newpagecomment": "Новый комментарий",
  "quick.reload.reload": "Перезагрузить страницу",
  "recently-updated-content-list.commented.new": "Прокомментировано: {time}",
  "recently-updated-content-list.created.new": "Создано: {time}",
  "recently-updated-content-list.edited.new": "Обновлено: {time}",
  "recently.viewed.mainBanner": "Пора творить историю",
  "recently.viewed.subBanner": "Вы еще не посетили ни одной страницы; как только это произойдет, они будут перемещены сюда, чтобы можно было быстро вернуться к ним позднее.",
  "recently.viewed.subBanner2": "Перейдите в <b>раздел</b> прямо сейчас и осмотритесь.",
  "recently.viewed.title": "Недавно посетил",
  "recently.worked.mainBanner": "Доведите шедевр до ума",
  "recently.worked.subBanner": "Вы еще ничего не создали и не отредактировали; как только это произойдет, объект будет перемещен сюда, чтобы можно было быстро продолжить с того места, где была прервана работа.",
  "recently.worked.subBanner2": "Создайте свое лучшее творение.",
  "recently.worked.title": "Недавняя работа",
  "remove.comment.confirmation.message": "Вы уверены что хотите удалить этот комментарий?",
  "remove.label": "Удалить метку",
  "resize.image.dialog.title": "Изменить размер изображения",
  "restore.this.version": "Восстановить",
  "result.grid.column.content.last.modified": "Последнее изменение",
  "resume.editing": "Продолжить",
  "return.to.page.info": "Вернутся к информации о странице",
  "satisfaction.survey.reaction.amazing": "Потрясающе",
  "satisfaction.survey.reaction.bad": "Плохо",
  "satisfaction.survey.reaction.great": "Отлично",
  "satisfaction.survey.reaction.okay": "Хорошо",
  "satisfaction.survey.reaction.terrible": "Ужасно",
  "save.name": "Сохранить",
  "scheme.desc.custom": "Пользовательская цветовая схема, которую можно редактировать.",
  "scheme.desc.global": "Эта цветовая схема будет использовать глобально определенную цветовую схему для данного раздела.",
  "scheme.title.custom": "Пользовательская Цветовая Схема",
  "scheme.title.global": "Глобальная Цветовая Схема",
  "search.drawer.recently.viewed": "Недавно просмотренные",
  "search.drawer.recently.viewed.spaces": "Недавние пространства",
  "search.name": "Поиск",
  "settings.name": "Настройки",
  "share.button.restriction.message.text": "Эта страница недоступна для просмотра и редактирования",
  "share.button.text": "Открыть доступ",
  "show.more.blogposts": "Показать другие записи в блоге",
  "sidebar.avatar.picker.upload.error": "Возникла ошибка при обновлении подробных данных раздела",
  "sidebar.main.back.to.overview": "Назад к Обзору",
  "sidebar.main.back.to.space": "Назад к разделу",
  "sidebar.main.blog": "Блог",
  "sidebar.main.quick.links": "Быстрые ссылки",
  "sidebar.main.settings": "Настройки раздела",
  "sidebar.main.shortcuts": "Ссылки",
  "sidebar.main.wiki": "Страницы",
  "site-settings.templates-and-blueprints.edit-button-label": "Изменить",
  "space.404.banner.title": "Ой, вы нашли мертвую ссылку",
  "space.404.go.back": "Вернутся к",
  "space.404.go.to": "Перейти к",
  "space.404.home.page": "главная страница",
  "space.404.previous.page": "предыдущая страница",
  "space.create": "Создать раздел",
  "space.home.blog.blankExperience.mainBanner": "Есть чем поделиться?",
  "space.home.blog.blankExperience.subBanner": "Сообщения в блогах — отличный способ поделиться объявлениями, отчетами о статусе или другими важными новостями с вашей командой.",
  "space.home.overview.blankExperience.mainBanner": "Ох, нам даже неловко...",
  "space.home.overview.blankExperience.subBanner": "В этом разделе нет главной страницы, так что показывать здесь нечего. Печалька.",
  "space.home.overview.blankExperience.subBanner2": "Добавьте главную страницу, чтобы тут стало уютней, и расскажите посетителям, что тут к чему.",
  "space.not.exists": "Раздел, которое вы указали, не существует.",
  "space.personal.name": "Личный раздел",
  "space.set.space.home": "Установить домашнюю страницу раздела",
  "space.watch.instruction": "Для просмотра страниц или блогов в разделе кликните на «Страницы» или «Блоги» на боковой панели пространства.",
  "space.watches": "Отслеживаемые разделы",
  "spaces.all": "Все разделы",
  "spaces.lookandfeel.help": "Здесь вы можете настроить вид этого раздела Confluence.",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">Примечание:</span> <i>Любые изменения, сделанные здесь, перепишут значения цветовой схемы и оформления по умолчанию, настроенные администратором.</i>",
  "spaces.word": "Разделы",
  "starred.mainBanner": "Здесь не на что смотреть... Пока",
  "starred.spaces.tooltip.add": "Отметить этот раздел",
  "starred.spaces.tooltip.remove": "Снять пометку с этого раздела",
  "starred.subBanner": "Нажмите на <b>иконку со звездой</b>, чтобы сохранить страницу на потом. Мы оставим ее здесь, чтобы вы смогли найти ее, когда она понадобится.",
  "starred.title": "Сохранено на будущее",
  "status.lozenge.draft": "Черновик",
  "status.lozenge.unpublished": "Неопубликованные изменения",
  "submit.name": "Применить",
  "super-admin.banner.exit": "Больше не использовать ключ администратора",
  "super-admin.banner.message": "Ключ администратора временно открывает для вас контент с ограниченным доступом.",
  "switch.apps": "Переключить приложения",
  "system.help.legal": "Юридическая помощь",
  "team.create.flag.error.description": "Не удалось создать команду. Повторите попытку позже.",
  "team.create.flag.error.title": "Произошла ошибка",
  "team.created.flag.description": "{membersCount, plural, one {Вы пригласили {membersCount} участника в команду «'{'teamName'}'»} few {Вы пригласили {membersCount} участника в команду «'{'teamName'}'»} many {Вы пригласили {membersCount} участников в команду «'{'teamName'}'»} other {Вы пригласили {membersCount} участника в команду «'{'teamName'}'»}}",
  "team.created.flag.title": "Команда создана",
  "team.created.flag.view": "Подробнее о команде",
  "template.variables.fabric.section.message": "Шаблон содержит переменные. Как только вы их введете, предоставленные данные появятся на новой странице.",
  "templates.name": "Шаблоны",
  "text.file": "Текстовый файл",
  "text.selected": "Выбран",
  "tinymce.advanced.block": "Формат",
  "tinymce.advanced.blockquote": "Цитата",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "Жирный",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "Маркированный список",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Shift+B",
  "tinymce.advanced.charmap_desc": "Символ",
  "tinymce.advanced.forecolor_desc": "Выберите цвет текста",
  "tinymce.advanced.formatting_desc": "Форматирование",
  "tinymce.advanced.h1": "Заголовок 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "Заголовок 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "Заголовок 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "Заголовок 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "Заголовок 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "Заголовок 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "Заголовки с 1 по 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "Горизонтальная линия",
  "tinymce.advanced.indent_desc": "Сделать отступ",
  "tinymce.advanced.italic_desc": "Курсив",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "Выровнять по центру",
  "tinymce.advanced.justifyfull_desc": "Выровнять по ширине",
  "tinymce.advanced.justifyleft_desc": "Выровнять по левому краю",
  "tinymce.advanced.justifyright_desc": "Выровнять по правому краю",
  "tinymce.advanced.numlist_desc": "Нумерованный список",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Shift+N",
  "tinymce.advanced.outdent_desc": "Убрать отступ",
  "tinymce.advanced.paragraph": "Абзац",
  "tinymce.advanced.paragraph_shortcut": "Ctrl +0",
  "tinymce.advanced.pre": "Выровненный",
  "tinymce.advanced.pre_shortcut": "Ctrl +7",
  "tinymce.advanced.redo_desc": "Восстановить",
  "tinymce.advanced.redo_shortcut": "Ctrl + Y",
  "tinymce.advanced.striketrough_desc": "Зачеркнутый",
  "tinymce.advanced.striketrough_shortcut": "Ctrl + Shift + S",
  "tinymce.advanced.sub_desc": "Нижний индекс",
  "tinymce.advanced.sup_desc": "Верхний индекс",
  "tinymce.advanced.tasklist_desc": "Список задач",
  "tinymce.advanced.tasklist_shortcut": "[ затем ]",
  "tinymce.advanced.underline_desc": "Подчеркнутый",
  "tinymce.advanced.underline_shortcut": "Ctrl + U",
  "tinymce.advanced.undo_desc": "Отменить",
  "tinymce.advanced.undo_shortcut": "Ctrl + Z",
  "tinymce.advanced.unlink_desc": "Удалить ссылку",
  "tinymce.atlassian.help": "Помощь",
  "tinymce.atlassian.insert_menu": "Вставить",
  "tinymce.atlassian.insert_menu.charmap_desc": "Вставить символ",
  "tinymce.atlassian.insert_menu.content_desc": "Добавить содержимое",
  "tinymce.atlassian.insert_menu.hr_desc": "Вставить горизонтальную линию (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "Вставить макрос",
  "tinymce.atlassian.insert_menu.tooltip": "Вставить прочий контент",
  "tinymce.atlassian.monospace": "Моноширинный",
  "tinymce.atlassian.monospace_desc": "Форматировать текст с моноширинным шрифтом",
  "tinymce.atlassian.more_menu": "Больше",
  "tinymce.atlassian.remove_formatting": "Очистить форматирование",
  "tinymce.atlassian.remove_formatting_desc": "Удаляет форматирование выделенного текста",
  "tinymce.auiwindowmanager.cancel": "Отменить",
  "tinymce.auiwindowmanager.ok": "ОК",
  "tinymce.autocomplete.web.resource.name": "Веб-ресурсы автоматического выполнения в Confluence",
  "tinymce.autocomplete.web.resource.only.name": "Веб-ресурсы автозавершения в Confluence (без зависимостей)",
  "tinymce.charmap.web.resource.name": "Веб-ресурсы для набора символов TinyMce",
  "tinymce.charmap_dlg.title": "Вставить символ",
  "tinymce.colorpicker.color": "Цвет",
  "tinymce.colorpicker.more_colors": "Дополнительные цвета",
  "tinymce.colorpicker.picker_tab": "Браузер",
  "tinymce.colorpicker.picker_title": "Cредство выбора цвета",
  "tinymce.colorpicker.title": "Выберите цвет",
  "tinymce.colorpicker.web.resource.name": "Веб-ресурсы выбора цвета в Confluence",
  "tinymce.confluence.conf_emoji": "Смайл",
  "tinymce.confluence.conf_emoticon": "Смайл",
  "tinymce.confluence.conf_emoticon_desc": "Вставить смайлик",
  "tinymce.confluence.conf_file": "Файлы и изображения",
  "tinymce.confluence.conf_file_desc": "Вставить файлы и изображения",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "Изображение",
  "tinymce.confluence.conf_image_desc": "Вставить изображения",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "Ссылка",
  "tinymce.confluence.conf_link_desc": "Вставить ссылку",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "Макрос",
  "tinymce.confluence.conf_macro_browser_desc": "Вставить макрос",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Shift+A",
  "tinymce.confluence.conf_media": "Изображение/Медиа",
  "tinymce.confluence.conf_other_macros_desc": "Другие макросы...",
  "tinymce.confluence.conf_shortcuts_help": "Справка по быстрым ссылкам на клавиатуре",
  "tinymce.confluence.conf_tasklist": "Список задач",
  "tinymce.confluence.conf_tasklist_desc": "Вставить список задач",
  "tinymce.confluence.conf_tasklist_shortcut": "[ затем ]",
  "tinymce.confluence.conf_widget_desc": "Виджет",
  "tinymce.confluence.conf_wikimarkup": "Разметка",
  "tinymce.confluence.conf_wikimarkup.insert.label": "Вставить",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Confluence wiki",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Ошибки преобразования Wiki-разметки",
  "tinymce.confluence.conf_wikimarkup_desc": "Вставить разметку",
  "tinymce.confluence.conf_wikimarkup_hint": "Подсказка: Вы также можете ввести разметку wiki непосредственно в редакторе, где она будет отформатирована при вводе",
  "tinymce.confluence.conf_wikimarkup_info_title": " Добавьте разметку в стиле wiki или markdown. Confluence сконвертирует это в формат редактора и добавит на страницу.",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "Markdown",
  "tinymce.confluence.conf_wikimarkup_preview_label": "Предпросмотр",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Shift+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "Сервер слишком долго выполнял преобразование wiki-разметки. Эта проблема может быть временной, попробуйте снова.",
  "tinymce.confluence.files": "Файлы",
  "tinymce.confluence.help_desc": "Помощь",
  "tinymce.confluence.htmlsource": "Источник",
  "tinymce.confluence.htmlsource_desc": "Просмотр HTML-кода",
  "tinymce.confluence.layout.menu": "Разметка страницы",
  "tinymce.confluence.layout.none": "Нет форматирования",
  "tinymce.confluence.layout.three_col": "Три колонки",
  "tinymce.confluence.layout.three_col_sidebars": "Три колонки (левая и правая боковые панели)",
  "tinymce.confluence.layout.three_col_simple": "Три колонки (простые)",
  "tinymce.confluence.layout.two_col": "Две колонки",
  "tinymce.confluence.layout.two_col_left": "Две колонки (левая боковая панель)",
  "tinymce.confluence.layout.two_col_right": "Две колонки (правая боковая панель)",
  "tinymce.confluence.layout.two_col_simple": "Две колонки (простые)",
  "tinymce.confluence.layout.two_col_simple_left": "Две колонки (простая, левая боковая панель)",
  "tinymce.confluence.layout.two_col_simple_right": "Две колонки (простые, правая боковая панель)",
  "tinymce.confluence.macro_insert": "Вставить макрос «'{'0'}'»",
  "tinymce.confluence.macro_other": "Другие макросы",
  "tinymce.confluence.macro_other_desc": "Открыть обзореватель макросов",
  "tinymce.confluence.placeholder.inline.tasks": "Укажите здесь вашу задачу, используя \"@\" для её связывания с пользователем и \"//\" для выбора её даты завершения.",
  "tinymce.confluence.preview": "Предпросмотр",
  "tinymce.confluence.preview_shortcut": "Ctrl+Shift+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "Настройки редактора",
  "tinymce.confluence_dlg.insertbutton.title": "Вставить",
  "tinymce.confluence_dlg.insertimage.title": "Вставить изображения",
  "tinymce.confluence_dlg.insertlink.title": "Вставить ссылку",
  "tinymce.emotions.emotions_desc": "Смайлы",
  "tinymce.emotions.web.resource.name": "Веб-ресурсы смайлов TinyMce",
  "tinymce.emotions_dlg.add": "Плюс (+)",
  "tinymce.emotions_dlg.biggrin": "Широкая улыбка :D",
  "tinymce.emotions_dlg.broken_heart": "Разбитое сердце </3",
  "tinymce.emotions_dlg.check": "Галочка ​​(/)",
  "tinymce.emotions_dlg.desc": "Смайлы",
  "tinymce.emotions_dlg.error": "Ошибка (x)",
  "tinymce.emotions_dlg.forbidden": "Минус (-)",
  "tinymce.emotions_dlg.heart": "Сердце <3",
  "tinymce.emotions_dlg.help_16": "Знак вопроса (?)",
  "tinymce.emotions_dlg.information": "Инфо (i)",
  "tinymce.emotions_dlg.lightbulb": "Лампочка не горит (выкл.)",
  "tinymce.emotions_dlg.lightbulb_on": "Лампочка горит (вкл.)",
  "tinymce.emotions_dlg.sad": "Грусть :(",
  "tinymce.emotions_dlg.smile": "Улыбка :)",
  "tinymce.emotions_dlg.star_blue": "Синяя звездочка (*b)",
  "tinymce.emotions_dlg.star_green": "Зеленая звездочка (*g)",
  "tinymce.emotions_dlg.star_red": "Красная звездочка (*r)",
  "tinymce.emotions_dlg.star_yellow": "Желтая звездочка (*y)",
  "tinymce.emotions_dlg.thumbs_down": "Палец вниз (n)",
  "tinymce.emotions_dlg.thumbs_up": "Большой палец (y)",
  "tinymce.emotions_dlg.title": "Вставить смайлик",
  "tinymce.emotions_dlg.tongue": "Язык :p",
  "tinymce.emotions_dlg.warning": "Предупреждение (!)",
  "tinymce.emotions_dlg.wink": "Подмигивание ;)",
  "tinymce.fabric.migration.dialog.action": "Продолжить редактирование",
  "tinymce.fabric.migration.dialog.content": "Не волнуйтесь, внесенные вами изменения не потеряны. Просто было необходимо обновить страницу.",
  "tinymce.fabric.migration.dialog.title": "Мы просто обновили интерфейс редактирования.",
  "tinymce.formatting.paragraph": "Нормальный текст",
  "tinymce.full_screen.toolbar_item": "Полный экран",
  "tinymce.full_screen.toolbar_item_title": "Запустить редактор на полный экран",
  "tinymce.hints.autoformat.code": "Подсказка. Чтобы быстро вставить моноширинный текст, введите «<strong>'{{'code'}}'</strong>».",
  "tinymce.hints.autoformat.heading1": "Подсказка: Введите \"<strong>h1. Title</strong>\" чтобы быстро вставить Заголовок 1.",
  "tinymce.hints.autoformat.heading3": "Подсказка: Введите <strong>\"h3 Title.\"</strong> чтобы быстро вставить Заголовок 3.",
  "tinymce.hints.dnd": "Подсказка: Вы можете перетаскивать изображения и файлы Office с компьютера прямо в этот редактор.",
  "tinymce.hints.drafts": "Подсказка: Confluence сохраняет черновики автоматически. Если Вы когда-нибудь потеряете окно, восстановите Вашу работу из меню \"Имя пользователя -> Черновики\".",
  "tinymce.hints.insert.bullet.list": "Подсказка: нажмите <strong>Ctrl+Shift+B</strong> чтобы создать маркированный список.",
  "tinymce.hints.insert.heading": "Подсказка: нажмите <strong>Ctrl+1</strong> чтобы создать заголовок 1-го уровня, <strong>Ctrl+2</strong> для заголовка 2-го уровня и так далее.",
  "tinymce.hints.insert.image": "Подсказка: нажмите <strong>Ctrl+M</strong> чтобы открыть браузер изображений.",
  "tinymce.hints.insert.image.end": "Подсказка: нажмите <strong>Ctrl+Shift+M</strong> после набора слова чтобы найти и вставить соотвествующие изображения.",
  "tinymce.hints.insert.image.on.page": "Подсказка: напишите \"<strong>!</strong>\" для просмотра вложенных в страницу изображений и вставить одно из них.",
  "tinymce.hints.insert.image.search": "Подсказка: напишите \"<strong>!</strong>\" и часть имени изображения чтобы найти и вставить изображение.",
  "tinymce.hints.insert.link": "Подсказка: нажмите <strong>Ctrl+K</strong> чтобы открыть браузер ссылок.",
  "tinymce.hints.insert.link.end": "Подсказка: нажмите <strong>Ctrl+Shift+K</strong> после набора слова для поиска ссылки на подходящую страницу. Нажмите комбинацию снова для повторения поиска совпадений.",
  "tinymce.hints.insert.link.newpage": "Подсказка: введите <strong>\"[\"</strong> и название новой страницы, которую Вы желаете создать, чтобы увидеть вставленную в предложение ссылку.",
  "tinymce.hints.insert.link.recently.viewed": "Подсказка: введите \"<strong>[</strong>\" чтобы просмотреть список страниц и вставить ссылку.",
  "tinymce.hints.insert.link.search": "Подсказка: введите \"<strong>[</strong>\" и часть заголовка страницы чтобы найти ссылку на эту страницу.",
  "tinymce.hints.insert.link.user.mention": "Подсказка: Вы можете упомянуть кого-то в Confluence, набрав \"<strong>@</strong>\" и затем его имя.",
  "tinymce.hints.insert.macro": "Подсказка: нажмите <strong>Ctrl+Shift+A</strong> чтобы открыть браузер макросов.",
  "tinymce.hints.insert.macro.toc": "Подсказка: позвольте системе Confluence сгенерировать оглавление для данной страницы. Используйте команду «Вставка -> Оглавление»",
  "tinymce.hints.insert.newline": "Подсказка: Введите <strong>Shift+Enter</strong> чтобы вставить новый абзац без пробела",
  "tinymce.hints.insert.numbered.list": "Подсказка: нажмите <strong>Ctrl+Shift+N</strong> для создания нумерованного списка.",
  "tinymce.hints.insert.table": "Подсказка: нажмите <strong>Ctrl+Shift+I</strong> чтобы вставить таблицу.",
  "tinymce.hints.insert.wikimarkup": "Подсказка: редактор автоматически преобразует разметку по мере ее ввода.",
  "tinymce.hints.insert.wikimarkup.dialog": "Подсказка: нажмите <strong>Ctrl+Shift+D</strong> чтобы открыть диалоговое окно разметки Wiki.",
  "tinymce.hints.table.rows.copy": "Подсказка: нажмите <strong>Ctrl+Shift+C</strong> чтобы скопировать строку и <strong>Ctrl+Shift+V</strong> чтобы вставить ее в таблицу.",
  "tinymce.hints.table.rows.cut": "Подсказка: нажмите <strong>Ctrl+Shift+X</strong> чтобы вырезать строку и  <strong>Ctrl+Shift+V</strong> чтобы вставить ее в таблицу.",
  "tinymce.macro.preview.exception": "Возникла ошибка при отображении макроса. Ошибка: {0}",
  "tinymce.macro.unknownMacro": "Неизвестный макрос «'{'0'}'». Возможно, он удален из системы.",
  "tinymce.popup_blocked": "Браузер заблокировал всплывающее окно от Редактора.",
  "tinymce.propertypanel.images.border": "Граница",
  "tinymce.propertypanel.images.border.tooltip": "Показать контур вокруг рисунка",
  "tinymce.propertypanel.images.large": "Крупный",
  "tinymce.propertypanel.images.large.tooltip": "Установить крупный размер изображения и вставить ссылку на оригинал",
  "tinymce.propertypanel.images.link.create": "Ссылка",
  "tinymce.propertypanel.images.link.create.tooltip": "Установить ссылку для изображения на другой контент",
  "tinymce.propertypanel.images.link.edit": "Редактировать ссылку",
  "tinymce.propertypanel.images.link.edit.tooltip": "Изменить ссылку изображения",
  "tinymce.propertypanel.images.link.remove": "Удалить ссылку",
  "tinymce.propertypanel.images.link.remove.tooltip": "Удалить ссылку на это изображение",
  "tinymce.propertypanel.images.medium": "Средний",
  "tinymce.propertypanel.images.medium.tooltip": "Установить средний размер изображения и вставить ссылку на оригинал",
  "tinymce.propertypanel.images.original": "Оригинальный",
  "tinymce.propertypanel.images.original.tooltip": "Установить оригинальный размер изображения",
  "tinymce.propertypanel.images.sizing.tooltip": "Установить определенный размер изображения",
  "tinymce.propertypanel.images.small": "Маленький",
  "tinymce.propertypanel.images.small.tooltip": "Установить маленький размер изображения и вставить ссылку на оригинал",
  "tinymce.propertypanel.links.edit": "Редактировать",
  "tinymce.propertypanel.links.edit.tooltip": "Показать диалог изменения ссылки",
  "tinymce.propertypanel.links.goto": "Пройти по ссылке",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "Эта ссылка ведет на содержимое редактируемой вами страницы",
  "tinymce.propertypanel.links.unlink": "Удалить ссылку",
  "tinymce.propertypanel.links.unlink.tooltip": "Замените ссылку с текстом этого содержимого",
  "tinymce.searchreplace.replace_desc": "Найти/Заменить",
  "tinymce.searchreplace.search_desc": "Найти",
  "tinymce.searchreplace_dlg.allreplaced.plural": "Выполнено {0} замен",
  "tinymce.searchreplace_dlg.allreplaced.singular": "Выполнена 1 замена",
  "tinymce.searchreplace_dlg.close": "Закрыть",
  "tinymce.searchreplace_dlg.direction": "Направление",
  "tinymce.searchreplace_dlg.down": "Вниз",
  "tinymce.searchreplace_dlg.findlabel": "Найти",
  "tinymce.searchreplace_dlg.findnext": "Далее",
  "tinymce.searchreplace_dlg.findprevious": "Назад",
  "tinymce.searchreplace_dlg.findwhat": "Что найти",
  "tinymce.searchreplace_dlg.mcase": "С учетом регистра",
  "tinymce.searchreplace_dlg.notfound": "Замены не выполнены",
  "tinymce.searchreplace_dlg.replace": "Заменить",
  "tinymce.searchreplace_dlg.replace_title": "Найти/Заменить",
  "tinymce.searchreplace_dlg.replaceall": "Заменить все",
  "tinymce.searchreplace_dlg.replacelabel": "Заменить",
  "tinymce.searchreplace_dlg.search_title": "Найти",
  "tinymce.searchreplace_dlg.searchnext_desc": "Повторить поиск",
  "tinymce.searchreplace_dlg.up": "Вверх",
  "tinymce.style.show-eol-markers": "¶",
  "tinymce.style.show-eol-markers.title": "Показать/скрыть маркеры конца строки",
  "tinymce.table": "Таблица",
  "tinymce.table.cell": "Ячейка",
  "tinymce.table.col": "Колонка",
  "tinymce.table.col_after_desc": "Вставить столбец после",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+Option+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "Вставить столбец до",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+Option+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "Копировать столбец таблицы",
  "tinymce.table.col_cut_desc": "Вырезать столбец таблицы",
  "tinymce.table.col_highlight": "Выделенная колонка",
  "tinymce.table.col_paste_desc": "Вставить столбец таблицы",
  "tinymce.table.copy_row_desc": "Копировать строку таблицы",
  "tinymce.table.copy_row_shortcut": "Ctrl+Shift+C",
  "tinymce.table.cut_row_desc": "Вырезать строку таблицы",
  "tinymce.table.cut_row_shortcut": "Ctrl+Shift+X",
  "tinymce.table.del": "Удалить таблицу",
  "tinymce.table.delete_col_desc": "Удалить столбец",
  "tinymce.table.delete_row_desc": "Удалить строку",
  "tinymce.table.desc": "Вставить таблицу",
  "tinymce.table.fixed_width": "С фиксированной шириной",
  "tinymce.table.fixed_width_tooltip": "Перетащите границы колонки, чтобы установить ширину колонки. Таблица всегда появляется с установленной вами шириной колонок.",
  "tinymce.table.highlight_colour": "Цвет выделения",
  "tinymce.table.merge_cells_desc": "Объединить ячейки таблицы",
  "tinymce.table.more.heading": "Настройки таблицы",
  "tinymce.table.numbering_column_desc": "Вставить числовой столбец",
  "tinymce.table.paste_row_after_desc": "Вставить строку после",
  "tinymce.table.paste_row_before_desc": "Вставить строку таблицы",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Shift+V",
  "tinymce.table.responsive": "Адаптивная",
  "tinymce.table.responsive_tooltip": "Колонки таблицы расширяются, когда вы добавляете содержимое. Перетащите границы колонки, чтобы установить ширину колонки относительно других колонок или ширины страницы",
  "tinymce.table.row": "Строка",
  "tinymce.table.row_after_desc": "Вставить строку после",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+Option+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt+↓",
  "tinymce.table.row_before_desc": "Вставить строку до",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+Option+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt+↑",
  "tinymce.table.row_highlight": "Выделенная строка",
  "tinymce.table.selection_highlight": "Изменение цвета ячейки",
  "tinymce.table.split_cells_desc": "Разделить объединенные ячейки таблицы",
  "tinymce.table_dlg.cols": "Столбцов",
  "tinymce.table_dlg.equal.width.columns": "Столбцы одинаковой ширины",
  "tinymce.table_dlg.fullwidth": "Полная ширина",
  "tinymce.table_dlg.heading": "Первая строка - заголовок",
  "tinymce.table_dlg.invalid_table_field": "Количество строк и столбцов должно быть большим нуля.",
  "tinymce.table_dlg.rows": "Строк",
  "tinymce.table_dlg.sizetofit": "Размер к содержимому",
  "tinymce.table_dlg.title": "Вставить таблицу",
  "tinymce.table_dlg.width": "Ширина",
  "tinymce.table_shortcut": "Ctrl+Shift+I",
  "tinymce.tablepicker.insert_table": "Таблица",
  "tinymce.tablepicker.insert_table_title": "Вставить таблицу",
  "tinymce.tablepicker.nested_table_unsupported": "Вложенные таблицы не поддерживаются",
  "tinymce.tablepicker.pickerbox.tooltip": "Удерживайте нажатой SHIFT для таблицы без заголовка.",
  "tinymce.templates.actions.defined": "Элементы для вставки на страницу.",
  "tinymce.templates.insert-template": "Шаблон",
  "tinymce.templates.insert-template.tooltip": "Вставить элементы шаблона на эту страницу.",
  "tinymce.templates.placeholder": "Текст инструкции",
  "tinymce.templates.placeholder.add": "Заполнитель",
  "tinymce.templates.placeholder.add.tooltip": "Вставьте текстовый заполнитель на страницу.",
  "tinymce.templates.placeholder.tooltip": "Исчезает по мере пользовательского ввода, не отображается при просмотре страницы.",
  "tinymce.templates.variables.add": "Новая переменная",
  "tinymce.templates.variables.add.tooltip": "Добавьте на страницу новое поле, которое должен заполнить пользователь шаблона.",
  "tinymce.templates.variables.defined": "Переменные для вставки на эту страницу.",
  "tinymce.templates.variables.insert.tooltip": "Вставьте на страницу поле «'{'0'}'», которое должен заполнить пользователь шаблона.",
  "tinymce.templates.variables.manage": "Управление переменными",
  "tinymce.templates.variables.none": "Переменные не определены",
  "tinymce.templates.variables.none.tooltip": "Переменные не созданы.",
  "tinymce.tools.toolbar_item_hide": "Скрыть инструменты",
  "tinymce.tools.toolbar_item_hide_title": "Скрыть панель инструментов",
  "tinymce.tools.toolbar_item_show": "Показать инструменты",
  "tinymce.tools.toolbar_item_show_title": "Показать панель инструментов",
  "tinymce.web.css.resource.name": "Веб-ресурсы CSS в редакторе Confluence",
  "tinymce.web.js.resource.name": "Веб-ресурсы Javascript в редакторе Confluence",
  "tinymce.web.resource.name": "Веб-ресурсы редактора Confluence",
  "title.add.blogpost": "Добавить новость",
  "title.add.page": "Добавить страницу",
  "title.add.page.template": "Создать шаблон",
  "title.comment": "Комментарий",
  "title.dashboard": "Рабочий стол",
  "title.edit.page.template": "Редактировать шаблон",
  "title.manage.groups": "Группы",
  "title.name": "Название",
  "type.allcontent": "Весь контент",
  "unknown.file": "Файл",
  "unsaved.comment.lost": "Ваш комментарий будет утерян.",
  "unsaved.content.lost": "Внесенные изменения, возможно, не сохранятся.",
  "unsaved.template.lost": "Несохраненные изменения шаблона будут утеряны.",
  "untitled.draft.title": "Без заголовка",
  "upm.marketplace.section": "Площадка Atlassian",
  "usermanagement.label": "Пользовательское управление",
  "usermanagement.parent.label": "Администрирование сайта",
  "users.name": "Пользователи",
  "view-changes-dialog.close.dialog": "Закрыть",
  "view-changes-dialog.editor.quit-dialog.title.diff": "Неопубликованные изменения",
  "view.change": "просмотреть изменение",
  "view.profile": "Просмотр профиля",
  "viewdrafts.page.desc": "Когда вы редактируете страницу, но не публикуете изменения, создается черновик. Нажмите <b>Возобновить</b>, чтобы продолжить редактирование или опубликовать изменения.",
  "welcome.message.edit": "Делитесь полезными ссылками, объявлениями и информацией здесь",
  "welcome.message.edit.link": "Настроить",
  "word.file": "Microsoft Word документ",
  "word.template.file": "Microsoft Word Шаблон",
  "word97.file": "Microsoft Word 97 документ",
  "word97.template.file": "Microsoft Word 97 шаблон",
  "xml.file": "XML Файл",
  "yes.name": "Да",
  "your.profile.and.settings": "Ваш профиль и настройки",
  "zip.file": "ZIP Архив"
}